import React, { Fragment, useState, useEffect, useContext, useCallback, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { AuthContext } from "../contexts/auth";
import { getDayCalendarWorkingHour } from '../services/api_calendar';
import { deleteEmployeeTimbratura, updateEmployeeTimbratura, createEmployeeTimbratura } from '../services/api_timbrature';
import { getJustificationsCompanyList } from '../services/api_justifications';
import { createEmployeeJustificationRequest, deleteJustificationRequest, updateJustificationRequestStatus } from '../services/api_justification_requests';
import { getCompanySettings } from '../services/api_settings';
import Swal from 'sweetalert2';
import moment from 'moment';
import Fetching from './fetching';
import { MapPinIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import LocationMap from './location_map';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import RunningWithErrorsOutlinedIcon from '@mui/icons-material/RunningWithErrorsOutlined';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import CustomTooltipComponent from './custom_tooltip_component';
import { PencilSquareIcon, TrashIcon, XMarkIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import ComboboxAutocomplete from './combobox_autocomplete';
import TimeInput from './time_input';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import MarkUnreadChatAltOutlinedIcon from '@mui/icons-material/MarkUnreadChatAltOutlined';
import OuSelectionPair from './modal_select_OU_to_pair';
import ModalSelectCreateShift from './modal_select_shift_day_create';
import { deleteEmployeeDailyWorkingHour, updateEmployeeWorkingHourStatus, updateEmployeeDWHOuPair, postNotificationDWH} from "../services/api_calendar";
import { estraiMessaggiErrore } from '../services/utils';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import AddLinkOutlinedIcon from '@mui/icons-material/AddLinkOutlined';
import OuSelectionPairDWH from './modal_select_OU_to_pair_DWH';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const DayDetailsModal = ({ isOpen, onClose, formattedDay, employee: dipendente, onAfterSaveTimbratura, onAfterDeleteTimbratura, onAfterSaveOrDeleteJustification, onNewJustificationAdded, onJustificationChanged, onOUChanged, isMonthOpen, onShiftsChanged, holidayToShow }) => {
    const { token, profile } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isForbidden, setIsForbidden] = useState(false);
    const [isLoadingJustification, setIsLoadingJustification] = useState(false);
    const [isErrorJustification, setIsErrorJustification] = useState(false);
    const [employeeDayDetails, setEmployeeDayDetails] = useState(null);
    const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
    const [locationData, setLocationData] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [editCheckIn, setEditCheckIn] = useState('');
    const [editCheckOut, setEditCheckOut] = useState('');
    const [newTimbratura, setNewTimbratura] = useState(null);
    const [showAddTimbraturaButton, setShowAddTimbraturaButton] = useState(true);
    const [editCheckInDate, setEditCheckInDate] = useState(formattedDay);
    const [editCheckOutDate, setEditCheckOutDate] = useState(formattedDay);
    const [newJustificationRow, setNewJustificationRow] = useState(null);
    const [editStartTime, setEditStartTime] = useState('');
    const [editEndTime, setEditEndTime] = useState('');
    const [selectedJustificationType, setSelectedJustificationType] = useState(null);
    const [giustificativi, setGiustificativi] = useState([]);
    const [justificationHasHours, setJustificationHasHours] = useState(true);
    const [expandedRows, setExpandedRows] = useState({});
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [showUnitSelection, setShowUnitSelection] = useState(false);
    const [selectedJustification, setSelectedJustification] = useState(null);
    const [editingNoteId, setEditingNoteId] = useState(null);
    const [editingNoteText, setEditingNoteText] = useState('');
    const [showAddShiftButton, setShowAddShiftButton] = useState(true);
    const [openModalShift, setOpenModalShift] = useState(false);
    const [isModalOuPairingDWHOpen, setIsModalOuPairingDWHOpen] = useState(false);
    const [selectedDWH, setSelectedDWH] = useState({});
    const [settingHiddenBreak, setSettingHiddenBreak] = useState(false);
    
    
    const controllerRef = useRef(null);

    const isEmployee = profile.customer_type === 'employee';

    const hasManageJustificationPermission =
        profile.employee?.permissions?.includes('hr.manage_justification_ou') ||
        profile.employee?.permissions?.includes('hr.manage_justification_all');

    const hasViewTimbraturePermission =
        profile.employee?.permissions?.includes('hr.view_inouts_ou') ||
        profile.employee?.permissions?.includes('hr.view_inouts_all');

    const hasManageTimbraturePermission =
        profile.employee?.permissions?.includes('hr.manage_inouts_ou') ||
        profile.employee?.permissions?.includes('hr.manage_inouts_all');

    const hasViewShiftsPermission =
        profile.employee?.permissions?.includes('hr.view_shifts_ou') ||
        profile.employee?.permissions?.includes('hr.view_shifts_all');

    const hasManageShiftsPermission =
        profile.employee?.permissions?.includes('hr.manage_shifts_ou') ||
        profile.employee?.permissions?.includes('hr.manage_shifts_all');

    const canViewShifts = !isEmployee || hasViewShiftsPermission || hasManageShiftsPermission;
    const canManageShifts = !isEmployee || hasManageShiftsPermission;
    const canViewInouts = !isEmployee || hasViewTimbraturePermission || hasManageTimbraturePermission;
    const canManageInouts = !isEmployee || hasManageTimbraturePermission;

    useEffect(() => {
        if (!token) return;
        
        let cancelled = false;
        (async () => {
            try {
            const settings = await getCompanySettings(token, 'payrolls');
            const allowHidden = Boolean(settings?.allow_hidden_breaks ?? false);
            if (!cancelled) setSettingHiddenBreak(allowHidden);
            } catch (e) {
            console.error('Errore caricamento setting:', e);
            if (!cancelled) setSettingHiddenBreak(false);
            }
        })();
    
        return () => { cancelled = true; };
    }, [token]);

    const openLocationMap = (inout) => {
        // Creiamo un array di posizioni
        const locations = [];
    
        if (inout.checkin_lat && inout.checkin_lng) {
            locations.push({
                latitude: inout.checkin_lat,
                longitude: inout.checkin_lng,
                accuracy: inout.checkin_accuracy || 50,
                type: 'checkin',
            });
        }
    
        if (inout.checkout_lat && inout.checkout_lng) {
            locations.push({
                latitude: inout.checkout_lat,
                longitude: inout.checkout_lng,
                accuracy: inout.checkout_accuracy || 50,
                type: 'checkout',
            });
        }
        
        setLocationData(locations);
        setIsLocationModalOpen(true);
    };
    
    const closeLocationModal = () => {
        setIsLocationModalOpen(false);
        setLocationData(null);
    };

    const fetchDayDetails = useCallback(async () => {
        if (!isOpen || !dipendente?.id || !formattedDay || !token) return;

        // aborta eventuale richiesta precedente
        if (controllerRef.current) {
        controllerRef.current.abort();
        }
        controllerRef.current = new AbortController();
        const signal = controllerRef.current.signal;

        try {
        setIsLoading(true);
        setIsError(false);
        setIsForbidden(false);

        const employeeId = dipendente.id;

        const calendarResponse = await getDayCalendarWorkingHour(
            token,
            formattedDay,
            null,
            [employeeId],
            1,
            10,
            signal,
            'shifts'
        );

        const modifiedCalendarResponse = calendarResponse.results.map((entry) => ({
            ...entry,
            days: entry.days.map((day) => ({
            ...day,
            justification_requests:
                isEmployee && !(hasManageJustificationPermission)
                ? []
                : day.justification_requests,
            inouts:
                isEmployee && !(hasViewTimbraturePermission || hasManageTimbraturePermission)
                ? []
                : day.inouts,
            shifts: day.shifts.map((shift) => ({
                ...shift,
                time_slots:
                isEmployee && !(hasViewShiftsPermission || hasManageShiftsPermission)
                    ? []
                    : shift.time_slots,
            })),
            })),
        }));

        const employeeDay = modifiedCalendarResponse.find(e => e.id === employeeId);
        const dayDetails = employeeDay?.days.find(day => day.date === formattedDay);
        
        setEmployeeDayDetails(dayDetails || null);
        } catch (error) {
        if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') return;
        console.error('Errore durante il caricamento dei dati:', error);
        if (error?.response?.status === 403) setIsForbidden(true);
        else setIsError(true);
        } finally {
        setIsLoading(false);
        }
    }, [
        isOpen,
        dipendente?.id,
        formattedDay,
        token,
        profile.customer_type,
        profile.employee?.permissions,
        hasManageJustificationPermission,
        hasViewTimbraturePermission,
        hasViewShiftsPermission,
    ]);

    useEffect(() => {
        fetchDayDetails();
        // onShiftsChanged?.();
        return () => {
        controllerRef.current?.abort();
        };
    }, [fetchDayDetails]);


    // useEffect(() => {
    //     const controller = new AbortController();
    //     const signal = controller.signal;

    //     const fetchData = async () => {
    //         if (isOpen && dipendente?.id && formattedDay && token) {
    //             const employeeId = dipendente.id;

    //             try {
    //                 setIsLoading(true);
    //                 setIsError(false);
    //                 setIsForbidden(false);

    //                 const calendarResponse = await getDayCalendarWorkingHour(
    //                     token,
    //                     formattedDay,
    //                     null,
    //                     [employeeId],
    //                     1, 
    //                     10,
    //                     signal,
    //                     'shifts'
    //                 );

    //                 const modifiedCalendarResponse = calendarResponse.results.map((entry) => ({
    //                     ...entry,
    //                     days: entry.days.map((day) => ({
    //                         ...day,
    //                         justification_requests:
    //                             isEmployee && !hasManageJustificationPermission
    //                                 ? []
    //                                 : day.justification_requests,
    //                         inouts: isEmployee && !hasViewTimbraturePermission ? [] : day.inouts,
    //                         shifts: day.shifts.map((shift) => ({
    //                             ...shift,
    //                             time_slots:
    //                                 isEmployee && !hasViewShiftsPermission ? [] : shift.time_slots,
    //                         })),
    //                     })),
    //                 }));

    //                 const employeeDayDetails = modifiedCalendarResponse.find(employee => employee.id === employeeId);
    //                 const dayDetails = employeeDayDetails?.days.find(day => day.date === formattedDay);

    //                 setEmployeeDayDetails(dayDetails);
    //                 setIsLoading(false);
    //             } catch (error) {
    //                 if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
    //                     return;
    //                 }

    //                 console.error("Errore durante il caricamento dei dati:", error);
    //                 if (error?.response?.status === 403) {
    //                     setIsForbidden(true);
    //                 } else {
    //                     setIsError(true);
    //                 }
    //                 setIsLoading(false);
    //             }
    //         }
    //     };

    //     fetchData();

    //     return () => {
    //         controller.abort();
    //     };
    // }, [isOpen, dipendente?.id, formattedDay, token, profile.employee?.permissions]);

    useEffect(() => {
        setIsLoadingJustification(true);
        setIsErrorJustification(false);

        const fetchData = async () => {
            if (isEmployee && !hasManageJustificationPermission) return;

            try {
                const giustificativi = await getJustificationsCompanyList(token, 'inoouts');
                setGiustificativi(giustificativi);
                setIsLoadingJustification(false);
            } catch (error) {
                console.error('Error fetching justifications:', error);
                setIsErrorJustification(true);
            }
        };

        fetchData();
    }, [token]);

    const formatCheckoutTime = (checkout, referenceDay) => {
        const checkoutMoment = moment(checkout);
        const isMidnightNextDay =
            checkoutMoment.format('HH:mm') === '00:00' &&
            checkoutMoment.isSame(moment(referenceDay).add(1, 'day'), 'day');

        if (isMidnightNextDay) return '24:00';

        return checkoutMoment.isSame(referenceDay, 'day')
            ? checkoutMoment.format('HH:mm')
            : checkoutMoment.format('DD/MM/YYYY HH:mm');
    };

    const startEditing = (inout) => {
        setEditingId(inout.id);

        if (inout.checkin) {
            const checkinMoment = moment(inout.checkin);
            setEditCheckIn(checkinMoment.format('HH:mm'));
            setEditCheckInDate(checkinMoment.format('YYYY-MM-DD'));
        } else {
            setEditCheckIn('');
            setEditCheckInDate(formattedDay);
        }

        if (inout.checkout) {
            const checkoutMoment = moment(inout.checkout);
            const isNextDayMidnight = checkoutMoment.format('HH:mm') === '00:00' &&
                checkoutMoment.isSame(moment(formattedDay).add(1, 'day'), 'day');

            if (isNextDayMidnight) {
                setEditCheckOut('24:00');
                setEditCheckOutDate(formattedDay);
            } else {
                setEditCheckOut(checkoutMoment.format('HH:mm'));
                setEditCheckOutDate(checkoutMoment.format('YYYY-MM-DD'));
            }
        } else {
            setEditCheckOut('');
            setEditCheckOutDate('');
        }
    };

    const cancelEditing = () => {
        setShowAddTimbraturaButton(true);
        setEditingId(null);
        setEditCheckIn('');
        setEditCheckOut('');
    };


    const handleSaveEdit = async (id) => {
        if (!editCheckIn) {
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: "L'orario di ingresso è obbligatorio",
                confirmButtonText: 'OK',
            });
            return;
        }

        const oldCheckinDate = moment(
            employeeDayDetails?.inouts?.find(t => t.id === id)?.checkin
        ).format('YYYY-MM-DD');
        
        const [checkinHours, checkinMinutes] = editCheckIn.split(':');
        const newCheckin = moment(editCheckInDate)
            .hours(checkinHours)
            .minutes(checkinMinutes)
            .seconds(0)
            .format('YYYY-MM-DDTHH:mm:ss');
        
        const [checkoutHours, checkoutMinutes] = editCheckOut.split(':');
        const newCheckout = editCheckOut
            ? moment(editCheckOutDate)
                .hours(checkoutHours)
                .minutes(checkoutMinutes)
                .seconds(0)
                .format('YYYY-MM-DDTHH:mm:ss')
            : null;

        const data = { checkin: newCheckin, checkout: newCheckout };

        try {
            await updateEmployeeTimbratura(token, dipendente.id, id, data);

            Swal.fire({
                title: 'Successo',
                text: 'Timbratura aggiornata con successo!',
                icon: 'success',
                showConfirmButton: false,
                timer: 1500,
            });

            const newDate = newCheckin.split('T')[0];
            const datesToUpdate = [...new Set([oldCheckinDate, newDate])];

            const updatedDays = {};

            for (const date of datesToUpdate) {
                const res = await getDayCalendarWorkingHour(
                    token,
                    date,
                    null,
                    [dipendente.id],
                    1,
                    1,
                    null,
                    'inoouts'
                );

                const updatedEmployee = res.results.find(emp => emp.id === dipendente.id);
                const day = updatedEmployee?.days.find(d => d.date === date);
                if (day) updatedDays[date] = day;
            }

            setEmployeeDayDetails(updatedDays[newDate] || null);
            setEditingId(null);
            setEditCheckIn('');
            setEditCheckOut('');
            setShowAddTimbraturaButton(true);

            if (onAfterSaveTimbratura) {
                const updatedInout = updatedDays[newDate]?.inouts?.find(io => io.id === id);
                if (updatedInout) {
                    onAfterSaveTimbratura(updatedInout, oldCheckinDate);
                }
            }

        } catch (error) {
            console.error('Errore aggiornamento:', error);
            let errorMessage = 'Non è stato possibile aggiornare la timbratura. Per favore riprova.';

            if (!error.response) {
                errorMessage = 'Errore, riprova più tardi.';
            } else if (error?.response?.data) {
                const messages = Object.values(error?.response?.data).flat();
                if (messages.length > 0) {
                    errorMessage = messages.join(' ');
                }
            }

            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });
        }
    };

    const handleAddNewRow = () => {
        setNewJustificationRow(null);
        setSelectedJustificationType(null);
        setEditStartTime('');
        setEditEndTime('');

        setNewTimbratura({ id: 'new' });
        setEditingId('new');
        setEditCheckIn('');
        setEditCheckOut('');
        setEditCheckInDate(formattedDay);
        setEditCheckOutDate(formattedDay);

        setShowAddTimbraturaButton(false);
    };

    const handleSaveNewTimbratura = async () => {
        if (!editCheckIn) {
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: "L'orario di ingresso è obbligatorio",
                confirmButtonText: 'OK',
            });
            return;
        }

        const checkinDateStr = editCheckInDate || formattedDay;
        const checkoutDateStr = editCheckOutDate || checkinDateStr;

        const [checkinHours, checkinMinutes] = editCheckIn.split(':');
        const checkinMoment = moment(checkinDateStr)
            .hours(checkinHours)
            .minutes(checkinMinutes)
            .seconds(0);

        const checkin = checkinMoment.format('YYYY-MM-DDTHH:mm:ss');

        let checkout = null;
        if (editCheckOut) {
            const [checkoutHours, checkoutMinutes] = editCheckOut.split(':');
            const checkoutMoment = moment(checkoutDateStr)
                .hours(checkoutHours)
                .minutes(checkoutMinutes)
                .seconds(0);

            checkout = checkoutMoment.format('YYYY-MM-DDTHH:mm:ss');
        }

        const data = { checkin, checkout };

        try {
            const response = await createEmployeeTimbratura(token, dipendente.id, data);

            Swal.fire({
                title: 'Successo',
                text: 'Timbratura aggiunta con successo!',
                icon: 'success',
                showConfirmButton: false,
                timer: 1500,
            });

            const calendarResponse = await getDayCalendarWorkingHour(
                token,
                formattedDay,
                null,
                [dipendente.id],
                1,
                10,
                null,
                'inoouts'
            );

            const updatedEmployee = calendarResponse.results.find(emp => emp.id === dipendente.id);
            const updatedDay = updatedEmployee?.days.find(day => day.date === formattedDay);

            setEmployeeDayDetails(updatedDay);
            setNewTimbratura(null);
            setEditingId(null);
            setEditCheckIn('');
            setEditCheckOut('');
            // dopo il salvataggio puoi azzerare o lasciare la data
            setEditCheckInDate('');
            setEditCheckOutDate('');
            setShowAddTimbraturaButton(true);

            if (onAfterSaveTimbratura) {
                const newlyCreatedTimbratura = updatedDay?.inouts.find(t => t.id === response.id);
                if (newlyCreatedTimbratura) {
                    onAfterSaveTimbratura(newlyCreatedTimbratura);
                }
            }

        } catch (error) {
            console.error('Errore aggiornamento:', error);
            let errorMessage = 'Non è stato possibile creare la timbratura. Per favore riprova.';

            if (!error.response) {
                errorMessage = 'Errore, riprova più tardi.';
            } else if (error?.response?.data) {
                const messages = Object.values(error?.response?.data).flat();
                if (messages.length > 0) {
                    errorMessage = messages.join(' ');
                }
            }

            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });
        }
    };

    const handleDeleteTimbratura = (timbratura) => {
        Swal.fire({
            title: 'Elimina Timbratura',
            text: 'Sei sicuro di voler eliminare questa timbratura?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteEmployeeTimbratura(token, dipendente.id, timbratura.id);

                    const calendarResponse = await getDayCalendarWorkingHour(
                        token,
                        formattedDay,
                        null,
                        [dipendente.id],
                        1,
                        10,
                        null,
                        'inoouts'
                    );

                    const updatedEmployee = calendarResponse.results.find(emp => emp.id === dipendente.id);
                    const updatedDay = updatedEmployee?.days.find(day => day.date === formattedDay);

                    setEmployeeDayDetails(updatedDay);

                    if (onAfterDeleteTimbratura && timbratura) {
                        onAfterDeleteTimbratura(timbratura);
                    }

                    Swal.fire({
                        title: 'Successo',
                        text: 'Timbratura eliminata con successo!',
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                } catch (error) {
                    console.error('Errore durante l\'eliminazione della timbratura:', error);
                    let errorMessage = 'Non è stato possibile eliminare la timbratura. Per favore riprova.';

                    if (!error.response) {
                        errorMessage = 'Errore, riprova più tardi.';
                    } else if (error?.response?.data) {
                        const messages = Object.values(error?.response?.data).flat();
                        if (messages.length > 0) {
                            errorMessage = messages.join(' ');
                        }
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Errore',
                        text: errorMessage,
                        confirmButtonText: 'OK',
                    });
                }
            }
        });
    };

    const handleAddNewJustificationRow = () => {
        setNewTimbratura(null);
        setEditingId(null);
        setEditCheckIn('');
        setEditCheckOut('');
        setShowAddTimbraturaButton(true);

        setNewJustificationRow({ id: 'new' });
        setSelectedJustificationType(null);
        setEditStartTime('');
        setEditEndTime('');
    };

    const handleJustificationTypeChange = (selectedOption) => {
        setSelectedJustificationType(selectedOption);
        setJustificationHasHours(selectedOption?.has_hours ?? true);

        if (!selectedOption?.has_hours) {
            setEditStartTime('00:00');
            setEditEndTime('24:00');
        } else {
            setEditStartTime('');
            setEditEndTime('');
        }
    };

    const handleSaveNewJustification = async () => {
        if (!selectedJustificationType || !editStartTime || !editEndTime) {
            Swal.fire({
                icon: 'warning',
                title: 'Compila tutti i campi',
            });
            return;
        }

        const datetimeFrom = `${formattedDay}T${editStartTime}:00`;
        const datetimeTo = editEndTime === '24:00'
            ? moment(formattedDay).add(1, 'day').format('YYYY-MM-DD') + 'T00:00:00'
            : `${formattedDay}T${editEndTime}:00`;

        const data = {
            datetime_from: datetimeFrom,
            datetime_to: datetimeTo,
            justification: selectedJustificationType.id,
            note: '',
            ou: dipendente?.unit_id ?? null,
        };

        try {
            await createEmployeeJustificationRequest(token, dipendente.id, data);
            Swal.fire({ icon: 'success', title: 'Salvato', timer: 1000, showConfirmButton: false });

            const calendarResponse = await getDayCalendarWorkingHour(
                token, formattedDay, null, [dipendente.id], 1, 10
            );

            const updatedEmployee = calendarResponse.results.find(emp => emp.id === dipendente.id);
            const updatedDay = updatedEmployee?.days.find(day => day.date === formattedDay);
            setEmployeeDayDetails(updatedDay);

            if (onAfterSaveOrDeleteJustification) {
                const hasJRs = (updatedDay?.justification_requests?.length ?? 0) > 0;
                onAfterSaveOrDeleteJustification(hasJRs);
            }

            if (onNewJustificationAdded) {
                onNewJustificationAdded(
                    {
                        date: formattedDay,
                        justification_requests: [
                            ...(employeeDayDetails?.justification_requests || []),
                            {
                                datetime_from: datetimeFrom,
                                datetime_to: datetimeTo,
                                justification: {
                                    id: selectedJustificationType.id,
                                    justification: selectedJustificationType,
                                },
                                status: null,
                                reviewed_on: null,
                            },
                        ],
                        ...employeeDayDetails,
                    },
                    dipendente.id,
                    formattedDay
                );
            }
            setNewJustificationRow(false);
            setSelectedJustificationType(null);
            setEditStartTime('');
            setEditEndTime('');
        } catch (error) {
            console.error('Errore salvataggio:', error);
            let errorMessage = 'Salvataggio fallito. Riprova.';

            if (!error.response) {
                errorMessage = 'Errore, riprova più tardi.';
            } else if (error?.response?.data) {
                const messages = Object.values(error?.response?.data).flat();
                if (messages.length > 0) {
                    errorMessage = messages.join(' ');
                }
            }

            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });
        }
    };
    
    const handleApproveJustification = async (justification) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Conferma approvazione',
            text: 'Vuoi approvare questo giustificativo?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Approva',
            cancelButtonText: 'Annulla',
        });

        if (isConfirmed) {
            const currentDate = new Date();

            try {
                await updateJustificationRequestStatus(token, justification.id, 'approved', currentDate);

                const updatedRequest = {
                    ...justification,
                    status: 'approved',
                    reviewed_on: currentDate,
                };

                setEmployeeDayDetails(prev => {
                    const updated = prev.justification_requests.map(req =>
                        req.id === updatedRequest.id ? updatedRequest : req
                    );
                    return {
                        ...prev,
                        justification_requests: updated,
                    };
                });

                if (onAfterSaveOrDeleteJustification) {
                    onAfterSaveOrDeleteJustification();
                }


                if (onJustificationChanged) {
                    const day = {
                        ...employeeDayDetails,
                        justification_requests: employeeDayDetails.justification_requests.map(req =>
                            req.id === justification.id
                                ? { ...req, status: 'approved', reviewed_on: currentDate }
                                : req
                        )
                    };

                    onJustificationChanged(day, dipendente.id, formattedDay);
                }

                Swal.fire({
                    icon: 'success',
                    title: 'Approvato',
                    text: 'Il giustificativo è stato approvato.',
                    timer: 1500,
                    showConfirmButton: false,
                });
            } catch (error) {
                console.error('Errore:', error);
                    let errorMessage = 'Errore durante l\'aggionamento della richiesta. Per favore riprova.';
            
                if (!error.response) {
                    errorMessage = 'Errore, riprova più tardi.';
                } else if (error.response && error.response.data) {
                    const errorData = error.response.data;
                    const errorMessages = [];
            
                    const extractMessages = (obj) => {
                    if (Array.isArray(obj)) {
                        obj.forEach(item => extractMessages(item));
                    } else if (typeof obj === 'object' && obj !== null) {
                        Object.values(obj).forEach(value => extractMessages(value));
                    } else if (typeof obj === 'string') {
                        errorMessages.push(obj);
                    }
                    };
            
                    extractMessages(errorData);
            
                    if (errorMessages.length > 0) {
                    errorMessage = errorMessages.join(' ');
                    }
                }
            
                Swal.fire({
                    icon: 'error',
                    title: 'Errore',
                    text: errorMessage,
                    confirmButtonText: 'OK',
                });
            }
        }
    };

    const handleRejectJustification = async (justification) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Conferma rifiuto',
            text: 'Vuoi rifiutare questo giustificativo?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Rifiuta',
            cancelButtonText: 'Annulla',
        });

        if (!isConfirmed) return;

        try {
            const currentDate = new Date();

            await updateJustificationRequestStatus(token, justification.id, 'rejected', currentDate);

            setEmployeeDayDetails(prev => {
                const updated = prev.justification_requests.filter(req => req.id !== justification.id);
                return {
                    ...prev,
                    justification_requests: updated
                };
            });

            if (onAfterSaveOrDeleteJustification) {
                onAfterSaveOrDeleteJustification();
            }

            if (onJustificationChanged) {
                const updatedDay = {
                    ...employeeDayDetails,
                    justification_requests: employeeDayDetails.justification_requests.filter(req => req.id !== justification.id)
                };

                onJustificationChanged(updatedDay, dipendente.id, formattedDay);
            }

            Swal.fire({
                icon: 'success',
                title: 'Rifiutato',
                text: 'Il giustificativo è stato rifiutato.',
                timer: 1500,
                showConfirmButton: false,
            });
        } catch (error) {
            console.error('Errore:', error);
                let errorMessage = 'Errore durante l\'aggionamento della richiesta. Per favore riprova.';
        
            if (!error.response) {
                errorMessage = 'Errore, riprova più tardi.';
            } else if (error.response && error.response.data) {
                const errorData = error.response.data;
                const errorMessages = [];
        
                const extractMessages = (obj) => {
                if (Array.isArray(obj)) {
                    obj.forEach(item => extractMessages(item));
                } else if (typeof obj === 'object' && obj !== null) {
                    Object.values(obj).forEach(value => extractMessages(value));
                } else if (typeof obj === 'string') {
                    errorMessages.push(obj);
                }
                };
        
                extractMessages(errorData);
        
                if (errorMessages.length > 0) {
                errorMessage = errorMessages.join(' ');
                }
            }
        
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });
        }
    };

    const handleDeleteJustification = async (justification) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Conferma Eliminazione',
            html: `<p class="text-gray-500">Sei sicuro di voler eliminare questa richiesta di giustificativo?</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sì, elimina',
            cancelButtonText: 'Annulla',
        });

        if (isConfirmed) {
            try {
                Swal.fire({
                    title: 'Eliminazione in corso...',
                    text: 'Attendere prego.',
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading()
                });

                await deleteJustificationRequest(token, justification.id);

                setEmployeeDayDetails((prevDetails) => {
                    if (!prevDetails?.justification_requests) return prevDetails;

                    const updatedRequests = prevDetails.justification_requests.filter(req => req.id !== justification.id);
                    const hasJRs = updatedRequests.length > 0;

                    if (onAfterSaveOrDeleteJustification) {
                        onAfterSaveOrDeleteJustification(hasJRs);
                    }

                    return {
                        ...prevDetails,
                        justification_requests: updatedRequests
                    };
                });

                if (onJustificationChanged) {
                    const updatedRequests = (employeeDayDetails.justification_requests || []).filter(
                        req => req.id !== justification.id
                    );

                    const day = {
                        ...employeeDayDetails,
                        justification_requests: updatedRequests,
                    };

                    onJustificationChanged(day, dipendente.id, formattedDay);
                }

                Swal.close();
                Swal.fire({
                    title: 'Eliminato!',
                    text: 'La richiesta è stata eliminata con successo.',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                });
            } catch (error) {
                console.error('Errore:', error);
                    let errorMessage = 'Errore eliminazione giustificativo. Per favore riprova.';
            
                if (!error.response) {
                    errorMessage = 'Errore, riprova più tardi.';
                } else if (error.response && error.response.data) {
                    const errorData = error.response.data;
                    const errorMessages = [];
            
                    const extractMessages = (obj) => {
                    if (Array.isArray(obj)) {
                        obj.forEach(item => extractMessages(item));
                    } else if (typeof obj === 'object' && obj !== null) {
                        Object.values(obj).forEach(value => extractMessages(value));
                    } else if (typeof obj === 'string') {
                        errorMessages.push(obj);
                    }
                    };
            
                    extractMessages(errorData);
            
                    if (errorMessages.length > 0) {
                    errorMessage = errorMessages.join(' ');
                    }
                }
            
                Swal.fire({
                    icon: 'error',
                    title: 'Errore',
                    text: errorMessage,
                    confirmButtonText: 'OK',
                });
            }
        }
    };

    const handleClose = () => {
        setIsLocationModalOpen(false);
        setLocationData(null);

        setNewJustificationRow(null);
        setEditStartTime('');
        setEditEndTime('');
        setSelectedJustificationType(null);
        setJustificationHasHours(true);

        setNewTimbratura(null);
        setEditingId(null);
        setEditCheckIn('');
        setEditCheckOut('');
        setShowAddTimbraturaButton(true);

        setShowAddShiftButton(true);

        onClose();
    };

    const toggleRowExpansion = (rowId) => {
    setExpandedRowId((prev) => (prev === rowId ? null : rowId));
    };

    const handleEditOU = (justification) => {
        setSelectedJustification(justification);
        setShowUnitSelection(true);
    };

    const handleSelectOUtoPair = async (selectedUnitToPair) => {
        if (!selectedJustification || !selectedUnitToPair) {
            console.error('Missing justification or OU ID.');
            return;
        }

        try {
            Swal.fire({
                title: 'Salvataggio in corso...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            const updatedJustification = await updateJustificationRequestStatus(
                token,
                selectedJustification.id,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                selectedUnitToPair.id
            );

            setEmployeeDayDetails(prev => {
                if (!prev) return prev;
                const updatedRequests = prev.justification_requests.map(j =>
                    j.id === selectedJustification.id
                        ? { ...j, ...updatedJustification }
                        : j
                );
                return { ...prev, justification_requests: updatedRequests };
            });

            Swal.close();
            Swal.fire({
                title: 'Salvato!',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
            });

            setShowUnitSelection(false);
            if (onOUChanged) {
                onOUChanged(dipendente.id, formattedDay);
            }
        } catch (error) {
            console.error('Errore aggiornamento OU:', error);
            Swal.close();

            let errorMessage = 'Errore durante l\'aggiornamento.';
            if (error.response?.data) {
                const flatMsg = Object.values(error.response.data).flat().join(', ');
                if (flatMsg) errorMessage = flatMsg;
            }

            Swal.fire({
                title: 'Errore!',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'Chiudi'
            });
        }
    };

    const handleDeletePairedUnit = async (justificationId) => {
        if (!justificationId) {
            console.error('Justification ID mancante.');
            return;
        }

        try {
            Swal.fire({
                title: 'Eliminazione in corso...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            const updatedJustification = await updateJustificationRequestStatus(
                token,
                justificationId,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                null
            );

            setEmployeeDayDetails(prev => {
                const updatedRequests = prev.justification_requests.map(r =>
                    r.id === justificationId ? { ...r, ou: null, ou_name: null } : r
                );
                return {
                    ...prev,
                    justification_requests: updatedRequests,
                };
            });

            Swal.close();
            Swal.fire({
                title: 'Salvato!',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
            });

            if (onOUChanged) {
                onOUChanged(dipendente.id, formattedDay);
            }
        } catch (error) {
            console.error('Errore durante l\'eliminazione dell\'unità associata:', error);
            Swal.close();
            let errorMessage = 'Si è verificato un errore durante l\'eliminazione dell\'unità associata.';

            if (!error.response) {
                errorMessage = 'Errore, riprova più tardi.';
            } else if (error?.response?.data) {
                const messages = Object.values(error?.response?.data).flat();
                if (messages.length > 0) {
                    errorMessage = messages.join(' ');
                }
            }

            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });
        }
    };

    const handleSaveNote = async (justificationId) => {
        if (!editingNoteText.trim()) return;

        try {
            Swal.fire({
                title: 'Salvataggio in corso...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            const updatedJustification = await updateJustificationRequestStatus(
                token,
                justificationId,
                undefined,
                undefined,
                undefined,
                undefined,
                editingNoteText,
                undefined
            );

            setEmployeeDayDetails(prev => {
                const updatedRequests = prev.justification_requests.map(r =>
                    r.id === justificationId ? { ...r, note: editingNoteText } : r
                );
                return { ...prev, justification_requests: updatedRequests };
            });

            setEditingNoteId(null);
            setEditingNoteText('');

            Swal.close();
            Swal.fire({
                title: 'Salvato!',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
            });

            if (onOUChanged) {
                onOUChanged(dipendente.id, formattedDay);
            }
        } catch (error) {
        console.error('Errore aggiornamento note:', error);
        Swal.close();

        let backendMsg = 'Errore durante il salvataggio della nota.';
        if (error?.response?.data) {
            const data = error.response.data;

            if (Array.isArray(data)) {
            backendMsg = data.join(' ');
            } else if (typeof data === 'object') {
            const msgs = Object.values(data)
                        .flat()
                        .filter(Boolean);
            if (msgs.length) backendMsg = msgs.join(' ');
            } else if (typeof data === 'string') {
            backendMsg = data;
            }
        }
        Swal.fire({
            title: 'Errore!',
            text: backendMsg,
            icon: 'error',
            confirmButtonText: 'Chiudi'
        });
        }
    };

    const handleDeleteNote = async (justificationId) => {
        try {
            Swal.fire({
                title: 'Eliminazione in corso...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            const updatedJustification = await updateJustificationRequestStatus(
                token,
                justificationId,
                undefined,
                undefined,
                undefined,
                undefined,
                null, // elimina nota
                undefined
            );

            setEmployeeDayDetails(prev => {
                const updatedRequests = prev.justification_requests.map(r =>
                    r.id === justificationId ? { ...r, note: null } : r
                );
                return { ...prev, justification_requests: updatedRequests };
            });

            Swal.close();
            Swal.fire({
                title: 'Note eliminate!',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
            });

            if (onOUChanged) {
                onOUChanged(dipendente.id, formattedDay);
            }

        } catch (error) {
            console.error('Errore eliminazione nota:', error);
            Swal.close();
            Swal.fire({
                title: 'Errore!',
                text: 'Errore durante l\'eliminazione della nota.',
                icon: 'error',
                confirmButtonText: 'Chiudi'
            });
        }
    };

    const handleUpdateShifts = useCallback(() => {
        fetchDayDetails();
        onShiftsChanged?.();
    }, [fetchDayDetails]);

    const handleAddNewShift = () => {
        setOpenModalShift(true);
        setShowAddShiftButton(false);
    };
    const handleCloseModalShift = () => {
        setOpenModalShift(false);
        setShowAddShiftButton(true);
    };


    const handleDeleteDailyWh = async (employee, shift) => {
        const canManage =
            profile.customer_type !== 'employee' ||
            profile.employee?.permissions.includes('hr.manage_shifts_all') ||
            profile.employee?.permissions.includes('hr.manage_shifts_ou');

        if (!canManage) {
            Swal.fire({
            icon: 'warning',
            title: 'Non hai i permessi per eseguire questa azione',
            confirmButtonText: 'OK'
            });
            return;
        }

        const employeeId = employee?.id;
        const dailyWhId  = shift?.daily_working_hour;
        const shiftStatus = shift?.status;
        const dayLabel   = moment(formattedDay).format('DD/MM/YYYY');

        const baseMsg = shiftStatus
            ? "Confermando, verrà eliminato il turno e verrà notificata l'azione al dipendente e ai gestori (se presenti)."
            : "Questa azione eliminerà il turno di lavoro selezionato.";

        const res = await Swal.fire({
            title: 'Confermi l\'eliminazione?',
            text: baseMsg,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#cbd5e1',
            cancelButtonText: 'Annulla',
            confirmButtonText: 'Sì, elimina!'
        });
        if (!res.isConfirmed) return;

        try {
            Swal.fire({
            title: 'Eliminazione in corso...',
            icon: 'info',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => Swal.showLoading(),
            });

            await deleteEmployeeDailyWorkingHour(token, employeeId, dailyWhId);

            await fetchDayDetails();
            onShiftsChanged?.();

            Swal.close();
            Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Turno giornaliero eliminato con successo!',
            showConfirmButton: false,
            timer: 1200,
            allowOutsideClick: false,
            allowEscapeKey: false
            });

            // (opzionale) notifica se era confermato
            if (shiftStatus) {
            try {
                const payload = {
                deleted_ids: {
                    [dailyWhId]: [employeeId, dayLabel, shift?.ref_ou || '']
                }
                };
                await postNotificationDWH(token, payload);
            } catch (notificationError) {
                console.error('Notifica non inviata:', notificationError);
                Swal.fire({
                icon: 'warning',
                title: 'Attenzione',
                text: 'Eliminazione eseguita, ma la notifica non è stata inviata.',
                confirmButtonText: 'OK'
                });
            }
            }
        } catch (error) {
            console.error('Errore durante l\'eliminazione:', error);
            Swal.close();
            Swal.fire(
            'Errore...',
            'Si è verificato un errore durante l\'eliminazione',
            'error'
            );
        }
    };

    const handleDeleteAllShifts = async (employeeDayDetails) => {
        const canManage =
            profile.customer_type !== 'employee' ||
            profile.employee?.permissions.includes('hr.manage_shifts_all') ||
            profile.employee?.permissions.includes('hr.manage_shifts_ou');

        if (!canManage) {
            Swal.fire({
            icon: 'warning',
            title: 'Non hai i permessi per eseguire questa azione',
            confirmButtonText: 'OK'
            });
            return;
        }

        if (!employeeDayDetails) return;

        const employeeId = dipendente?.id;
        const dayLabel   = moment(formattedDay).format('DD/MM/YYYY');
        const employeeName = dipendente?.last_name && dipendente?.first_name
            ? `${dipendente.last_name} ${dipendente.first_name}`
            : dipendente?.cf;

        const pendingDwhIds = Array.from(
            new Set(
            (employeeDayDetails.shifts || [])
                .filter(s => s?.status === false && s?.daily_working_hour)
                .map(s => s.daily_working_hour)
            )
        );

        if (pendingDwhIds.length === 0) {
            Swal.fire({
            icon: 'info',
            title: 'Nessun turno da eliminare',
            text: 'Non ci sono turni in attesa di conferma per questa giornata.',
            confirmButtonText: 'OK'
            });
            return;
        }

        const { isConfirmed } = await Swal.fire({
            title: 'Eliminare tutti i turni da confermare?',
            html: `
            <div class="text-sm text-gray-700">
                Data: <b>${dayLabel}</b><br/>
                Turni da eliminare: <b>${pendingDwhIds.length}</b><br/><br/>
                Confermando, verranno eliminati tutti i turni non confermati della giornata selezionata del dipendente ${employeeName}.
            </div>
            `,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#cbd5e1',
            cancelButtonText: 'Annulla',
            confirmButtonText: 'Sì, elimina tutti'
        });
        if (!isConfirmed) return;

        try {
            Swal.fire({
            title: 'Eliminazione in corso...',
            icon: 'info',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => Swal.showLoading(),
            });

            const deletions = pendingDwhIds.map(dwhId =>
            deleteEmployeeDailyWorkingHour(token, employeeId, dwhId)
            );
            const results = await Promise.allSettled(deletions);

            const successCount = results.filter(r => r.status === 'fulfilled').length;
            const failCount    = results.length - successCount;

            await fetchDayDetails();
            onShiftsChanged?.();

            Swal.close();
            await Swal.fire({
            position: 'center',
            icon: failCount === 0 ? 'success' : 'warning',
            title: failCount === 0
                ? 'Tutti i turni sono stati eliminati con successo!'
                : `Eliminazione completata con avvisi`,
            text: failCount === 0
                ? `Turni eliminati: ${successCount}`
                : `Eliminati: ${successCount}. Non riusciti: ${failCount}.`,
            showConfirmButton: true,
            });

            // 5) (opzionale) invia notifica cumulativa se i DWH erano “confermati”.
            // In questo caso stiamo eliminando solo i "non confermati" (status=false),
            // quindi probabilmente NON serve. Se ti serve comunque, puoi preparare un payload:
            //
            const payload = {
                deleted_ids: Object.fromEntries(
                    pendingDwhIds.map(id => [id, [employeeId, dayLabel, '']])
                 )
            };
            try { await postNotificationDWH(token, payload); } catch (e) { console.error('Errore durante l’invio della notifica:', e); }

        } catch (error) {
            console.error('Errore durante l’eliminazione multipla:', error);
            Swal.close();
            Swal.fire(
            'Errore...',
            'Si è verificato un errore durante l’eliminazione dei turni',
            'error'
            );
        }
    };

    const handleConfirmDWH = async (shift) => {
        const dwhId = shift?.daily_working_hour;
        if (!dwhId) return;

        // mese aperto?
        if (!isMonthOpen) {
            await Swal.fire({
            title: 'Mese bloccato',
            text: 'Non è possibile confermare il turno per questo mese.',
            icon: 'warning',
            confirmButtonText: 'OK',
            });
            return;
        }

        const { isConfirmed } = await Swal.fire({
            title: 'Confermi il turno selezionato?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#cbd5e1',
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
        });
        if (!isConfirmed) return;

        try {
            Swal.fire({
            title: 'Conferma in corso...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
            showConfirmButton: false,
            });

            await updateEmployeeWorkingHourStatus(token, dipendente?.id, dwhId);

            await fetchDayDetails();
            onShiftsChanged?.();

            Swal.close();
            await Swal.fire({
            title: 'Turno confermato!',
            icon: 'success',
            showConfirmButton: false,
            timer: 1200,
            });

            // notifica (best-effort)
            try {
                await postNotificationDWH?.(token, { approved_ids: [dwhId] });
            } catch (e) {
                console.warn('Notifica non inviata', e);
            }
        } catch (error) {
            console.error('Errore conferma DWH:', error);
            Swal.close();

            const beMsg =
            error?.response?.data?.non_field_errors?.join('\n') ||
            error?.response?.data?.detail ||
            error?.message ||
            'Problema durante la conferma del turno.';

            await Swal.fire('Errore', beMsg, 'error');
        }
    };

    const handleConfirmAllShifts = async (dayDetails) => {
        if (!dayDetails || !Array.isArray(dayDetails.shifts)) return;

        const employeeId = dipendente?.id;

        const pendingDwhIds = [
            ...new Set(
            (dayDetails.shifts || [])
                .filter(s => s?.status === false && s?.daily_working_hour != null)
                .map(s => s.daily_working_hour)
            )
        ];

        if (pendingDwhIds.length === 0) {
            await Swal.fire({
            icon: 'info',
            title: 'Nessun turno da confermare',
            text: 'Non ci sono turni da confermare per questa giornata.',
            confirmButtonText: 'OK'
            });
            return;
        }

        if (!isMonthOpen) {
            await Swal.fire({
            title: 'Mese bloccato',
            text: 'Non è possibile confermare i turni per questo mese.',
            icon: 'warning',
            confirmButtonText: 'OK'
            });
            return;
        }

        const plural = pendingDwhIds.length > 1;
        const { isConfirmed } = await Swal.fire({
            title: 'Stai confermando i turni',
            text: `Confermi la pubblicazione di ${pendingDwhIds.length} turn${plural ? 'i' : 'o'}? ` +
                `L'azione verrà notificata al dipendente e ai gestori, se presenti.`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#cbd5e1',
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
        });
        if (!isConfirmed) return;

        try {
            Swal.fire({
            title: 'Conferma in corso...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
            });

            const results = await Promise.allSettled(
            pendingDwhIds.map(dwhId => updateEmployeeWorkingHourStatus(token, employeeId, dwhId))
            );

            const succeededIds = [];
            const failed = [];
            results.forEach((res, idx) => {
            const id = pendingDwhIds[idx];
            if (res.status === 'fulfilled') {
                succeededIds.push(id);
            } else {
                const msg = estraiMessaggiErrore(res.reason);
                failed.push({ id, error: msg });
            }
            });

            await fetchDayDetails();
            onShiftsChanged?.();

            Swal.close();

  
            if (succeededIds.length === pendingDwhIds.length) {
            // tutti ok
            await Swal.fire({
                title: 'Turni confermati!',
                icon: 'success',
                showConfirmButton: false,
                timer: 1500,
            });
            } else if (succeededIds.length > 0) {
            // parziale
            const escapeHtml = (s) =>
            String(s).replace(/[&<>"']/g, (ch) => (
                { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]
            ));

            const htmlErrorList = `
            <div style="text-align:left">
                <div><b>Confermati:</b> ${succeededIds.length}</div>
                <div><b>Falliti:</b> ${failed.length}</div>
                <hr/>
                <div><b>Dettagli errori</b></div>
                <ol style="margin:8px 0 0 18px; padding-left: 18px">
                ${failed.map((f, i) => `<li>${i + 1}. ${escapeHtml(f.error)}</li>`).join('')}
                </ol>
            </div>
            `;
            await Swal.fire({
                title: 'Conferma parziale',
                html: htmlErrorList,
                icon: 'warning',
                confirmButtonText: 'OK',
                width: 600,
            });
            } else {
            // tutti KO
            const escapeHtml = (s) =>
            String(s).replace(/[&<>"']/g, (ch) => (
                { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]
            ));

            const htmlErrorList = `
            <div style="text-align:left">
                <div><b>Confermati:</b> ${succeededIds.length}</div>
                <div><b>Falliti:</b> ${failed.length}</div>
                <hr/>
                <div><b>Dettagli errori</b></div>
                <ol style="margin:8px 0 0 18px; padding-left: 18px">
                ${failed.map((f, i) => `<li>${i + 1}. ${escapeHtml(f.error)}</li>`).join('')}
                </ol>
            </div>
            `;
            await Swal.fire({
                title: 'Nessun turno confermato',
                html: htmlErrorList,
                icon: 'error',
                confirmButtonText: 'OK',
                width: 600,
            });
        }

        // (opzionale) invia notifica solo per quelli riusciti
        if (succeededIds.length > 0) {
            try {
                await postNotificationDWH?.(token, { approved_ids: succeededIds });
            } catch (e) {
                console.warn('Notifica non inviata:', e);
            }
        }

    } catch (error) {
        console.error('Errore nella conferma dei turni:', error);
        Swal.close();
        await Swal.fire({
        title: 'Errore!',
        text: 'Si è verificato un problema durante la conferma dei turni.',
        icon: 'error',
        confirmButtonText: 'OK',
        });
    }
    };


    // if (isLoading) return <Fetching />;
    // if (isError) return <div>Error occurred while fetching data</div>;
    // if (isForbidden) return <div>Access Denied</div>;

    const toDailyWhPayload = (employeeId, shift) => ({
        employee: employeeId,
        dailyWh: {
            dailyWorkingHourId: shift?.daily_working_hour ?? null,
            ref_name:  shift?.ref_name ?? null,
            ref_ou:    shift?.ref_ou ?? null,
            status:    Boolean(shift?.status),
            time_slots: Array.isArray(shift?.time_slots) ? shift.time_slots : [],
            typology:  shift?.typology ?? null,
        },
        });

    const handleModalOuPairingDWH = (employeeId, shift) => {
        if (!employeeId || !shift?.daily_working_hour) return;
   
        
        if (shift?.typology !== 'custom') {
            Swal.fire({
            icon: 'info',
            title: 'Operazione non consentita',
            text: 'Non è possibile collegare un’Unità ad un turno giornaliero.',
            confirmButtonText: 'OK'
            });
            return;
        }

        const dailywh = toDailyWhPayload(employeeId, shift);
        setSelectedDWH(dailywh);
        setIsModalOuPairingDWHOpen(true);
    };

    const closeModalPairingOuDWH = () => {
        setIsModalOuPairingDWHOpen(false);
        setSelectedDWH(null);
    };

    const handleSelectOUtoPairDWH = async (selectedUnit, dailyWhId, employeeId) => {
        try {
            const ouId   = selectedUnit ? selectedUnit.id   : null;
            const ouName = selectedUnit ? selectedUnit.name : null;

            Swal.fire({
                title: 'Salvataggio in corso...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });

            // API
            await updateEmployeeDWHOuPair(token, employeeId, dailyWhId, ouId);

            // Aggiorna lo stato locale (UI immediata)
            setEmployeeDayDetails(prev => {
            if (!prev) return prev;
            const newRefName = ouName ? `FASCIA ORARIA - Unità: ${ouName}` : null;

            return {
                ...prev,
                shifts: (prev.shifts || []).map(s =>
                s.daily_working_hour === dailyWhId
                    ? {
                        ...s,
                        ref_ou: ouId,
                        ref_ou_name: ouName,
                        ref_name: newRefName ?? s.ref_name,
                    }
                    : s
                ),
            };
            });

            // Chiudi il loading e mostra il toast di successo
            Swal.close();
            await Swal.fire({
            icon: 'success',
            title: 'Salvato!',
            showConfirmButton: false,
            timer: 1000,
            });

            // Torna alla modale precedente
            closeModalPairingOuDWH();

        } catch (error) {
            console.error('Failed to update:', error);
            Swal.close();

            // Estrai un messaggio di errore “umano”
            const msg =
            error?.response?.data?.detail
            || (typeof error?.response?.data === 'string' && error.response.data)
            || // prova a prendere il primo messaggio nel payload
                (error?.response?.data && Object.values(error.response.data).flat?.().join?.('\n'))
            || 'Collegamento unità non riuscito';

            await Swal.fire({
            icon: 'error',
            title: 'Errore',
            text: String(msg),
            confirmButtonText: 'OK',
            });
        }
    };

    if (!isOpen) return null;

    const { time_slots, justification_requests, inouts } = employeeDayDetails || {};


    
    return (
        <>
            <div>
                <Transition.Root show={isOpen && !showUnitSelection && !openModalShift && !isModalOuPairingDWHOpen} as={Fragment}>
                    <Dialog as="div" className="fixed inset-0 overflow-y-auto top-0" style={{ zIndex: '400' }} onClose={onClose}>
                        <div className="flex items-start justify-center min-h-screen px-4 text-center sm:block sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
                            </Transition.Child>

                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <div className="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-2/3 sm:w-2/3 mt-16">
                                    <div className="relative pb-2 pt-3 border-b border-gray-200 bg-indigo-200">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-semibold text-indigo-700 text-center"
                                        >
                                            Dettagli Giorno {moment(formattedDay).format('DD/MM/YYYY')}
                                        </Dialog.Title>
                                        {Array.isArray(holidayToShow) && holidayToShow.length > 0 && (
                                            <Dialog.Title
                                                as="h4"
                                                className="text-sm font-semibold text-orange-600/80 uppercase text-center"
                                            >
                                                Festività {holidayToShow.map(h => h.name).join(", ")}
                                            </Dialog.Title>
                                        )}
                                        {!isMonthOpen && (
                                            <Dialog.Title
                                                as="h4"
                                                className="text-sm pt-2 font-semibold text-indigo-700 text-center"
                                            >
                                                Il giorno selezionato è bloccato e non potranno essere effettuate modifiche
                                            </Dialog.Title>
                                        )}

                                        <button
                                            onClick={handleClose}
                                            className="absolute right-4 top-3 text-indigo-700 hover:text-gray-500 text-xl font-bold focus:outline-none"
                                            aria-label="Chiudi"
                                        >
                                            ×
                                        </button>
                                    </div>
                                    <div className="p-4">
                                        {isError ? (
                                            <div className="text-center text-red-500 font-semibold">
                                                Errore nel caricamento dei dati
                                            </div>
                                        ) : isForbidden ? (
                                            <div className="text-center text-red-500 font-semibold">
                                                Accesso negato
                                            </div>
                                        ) : (isLoading || !employeeDayDetails) ? (
                                            <Fetching />
                                        ) : (
                                            <>
                                                <div className='p-4'>
                                                    <div className='grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-6 gap-2 w-full p-2'>
                                                        <div className='col-span-1 font-semibold text-sm text-gray-600 uppercase pt-1'>
                                                            Dipendente
                                                        </div>
                                                        <div className='col-span-1 sm:col-span-3 lg:col-span-5 text-sm flex items-center uppercase font-semibold'>
                                                            {dipendente.last_name && dipendente.first_name ? `${dipendente.last_name} ${dipendente.first_name}` : dipendente.cf}
                                                        </div>
                                                        {(canViewShifts || canManageShifts) ? (
                                                            <>
                                                                <div className="font-semibold text-sm text-gray-600 pt-1 col-span-1">
                                                                    <div className='uppercase'>Fasce orarie lavoro</div>
                                                                    {canManageShifts && (employeeDayDetails?.shift_type !== 'fisso' && employeeDayDetails?.shift_type !== 'senza_calendario') && (
                                                                        <div className="mt-1">
                                                                            {showAddShiftButton && isMonthOpen && (
                                                                                <CustomTooltipComponent title="Aggiungi" placement="top-start" arrow>
                                                                                    <button
                                                                                        onClick={handleAddNewShift}
                                                                                        className="inline-flex items-center gap-1 rounded bg-indigo-400 px-2 text-xs font-semibold text-white hover:bg-indigo-500 uppercase"
                                                                                    >
                                                                                        <AddOutlinedIcon style={{ width: '1rem', color: 'white' }} />
                                                                                    </button>
                                                                                </CustomTooltipComponent>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    
                                                                    {employeeDayDetails?.shift_type === 'fisso' && (
                                                                        <div className="mt-1 mb-3 text-indigo-600 text-xs">
                                                                            <div>Turno Fisso</div>

                                                                            {employeeDayDetails?.ref_ou_name && (
                                                                            <div className="mt-1">
                                                                                <CustomTooltipComponent title="Unità collegata al turno" arrow>
                                                                                <span className="inline-flex items-center gap-1 text-[10px] text-indigo-700 bg-indigo-100 py-0.5 px-1 rounded-lg">
                                                                                    <AttachFileOutlinedIcon style={{ width: 12, height: 12 }} />
                                                                                    {employeeDayDetails.ref_ou_name}
                                                                                </span>
                                                                                </CustomTooltipComponent>
                                                                            </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    {employeeDayDetails?.shift_type === 'senza_calendario' && (
                                                                        <div className="mt-1 mb-3 text-indigo-600 text-xs">
                                                                            <div>Senza Calendario</div>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <div className="text-sm col-span-1 sm:col-span-3 lg:col-span-5 overflow-x-auto">
                                                                    {employeeDayDetails?.shifts && employeeDayDetails.shifts.length > 0 ? (
                                                                        <div>
                                                                            <table className="table-auto w-full text-sm mb-2">
                                                                                <thead>
                                                                                    <tr className="bg-gray-100">
                                                                                        {employeeDayDetails?.shift_type != 'fisso' && (
                                                                                            <th className="px-2 py-1 text-left">Stato</th>
                                                                                        )}
                                                                                        <th className="px-2 py-1 text-left">Inizio Turno</th>
                                                                                        <th className="px-2 py-1 text-left">Fine Turno</th>
                                                                                        <th className="px-2 py-1 text-left">Inizio Pausa</th>
                                                                                        <th className="px-2 py-1 text-left">Fine Pausa</th>
                                                                                        {employeeDayDetails?.shift_type != 'fisso' && (
                                                                                            <>
                                                                                                <th className="px-2 py-1 text-right"></th>
                                                                                                <th className="px-2 py-1 text-right"></th>
                                                                                            </>
                                                                                        )}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {employeeDayDetails.shifts.map((shift, shiftIndex) => {
                                                                                        const slots       = Array.isArray(shift.time_slots) ? shift.time_slots : [];
                                                                                        const isPending   = shift.status === false;
                                                                                        const isFisso     = employeeDayDetails?.shift_type === 'fisso';
                                                                                        const ouName      = shift?.ref_ou_name ?? null;
                                                                                        const hasOU       = !!shift?.ref_ou;
                                                                                        const canPair     = shift?.typology === 'custom';
                                                                                        const isWH        = shift?.typology === 'working_hour';
                                                                                        const rowSpanSize = Math.max(slots.length, 1);
                                                                                        const pendingBg   = isPending ? 'bg-orange-100' : '';

                                                                                        return slots.map((timeSlot, timeSlotIndex) => (
                                                                                        <tr
                                                                                            key={`${shiftIndex}-${timeSlotIndex}`}
                                                                                            className={isPending ? 'bg-orange-100' : ''}
                                                                                        >
                                                                                            {/* STATO + OU (solo prima riga del DWH, sempre con rowSpan) */}
                                                                                            {timeSlotIndex === 0 && !isFisso && (
                                                                                            <td
                                                                                                className={`px-2 py-1 align-top border-b ${pendingBg}`}
                                                                                                rowSpan={rowSpanSize}
                                                                                            >
                                                                                                {/* Stato */}
                                                                                                {isPending ? (
                                                                                                <CustomTooltipComponent title="Turno da confermare" placement="left" arrow>
                                                                                                    <PendingActionsOutlinedIcon style={{ width: 20, height: 20, color: '#f97316' }} />
                                                                                                </CustomTooltipComponent>
                                                                                                ) : (
                                                                                                <CustomTooltipComponent title="Turno confermato" placement="left" arrow>
                                                                                                    <CheckCircleOutlineOutlinedIcon style={{ width: 20, height: 20, color: '#22C55E' }} />
                                                                                                </CustomTooltipComponent>
                                                                                                )}

                                                                                                {/* OU / Azioni OU */}
                                                                                                {(() => {
                                                                                                if (isWH) {
                                                                                                    // Working hour: non editabile
                                                                                                    return hasOU ? (
                                                                                                        <CustomTooltipComponent title={ouName} placement="top-end" arrow>
                                                                                                            <span className="pl-4 text-indigo-700 align-middle opacity-70 cursor-not-allowed">
                                                                                                            <AttachFileOutlinedIcon className="text-indigo-700 bg-indigo-100 rounded-full p-0.5" style={{ width: 24, height: 24 }} />
                                                                                                            </span>
                                                                                                        </CustomTooltipComponent>
                                                                                                    ) : (
                                                                                                        <CustomTooltipComponent title="Turno giornaliero" placement="top-end" arrow>
                                                                                                            <span className="pl-4 text-indigo-700 align-middle">
                                                                                                            <InfoOutlinedIcon className="text-indigo-700 bg-indigo-100 rounded-full p-0.5" style={{ width: 24, height: 24 }} />
                                                                                                            </span>
                                                                                                        </CustomTooltipComponent>
                                                                                                    );
                                                                                                }

                                                                                                if (!canPair) return null;

                                                                                                const onClickAttach = (e) => {
                                                                                                    e.stopPropagation();
                                                                                                    if (!canManageShifts) {
                                                                                                    Swal.fire({
                                                                                                        icon: 'warning',
                                                                                                        title: 'Non hai i permessi per eseguire questa azione.',
                                                                                                        confirmButtonText: 'OK',
                                                                                                    });
                                                                                                    return;
                                                                                                    }
                                                                                                    handleModalOuPairingDWH(dipendente?.id, shift);
                                                                                                };

                                                                                                return hasOU ? (
                                                                                                    <CustomTooltipComponent title={ouName} placement="top-end" arrow>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="pl-4 text-indigo-700 align-middle"
                                                                                                            onClick={onClickAttach}
                                                                                                        >
                                                                                                            <AttachFileOutlinedIcon className="text-indigo-700 bg-indigo-100 rounded-full p-0.5" style={{ width: 24, height: 24 }} />
                                                                                                        </button>
                                                                                                    </CustomTooltipComponent>
                                                                                                ) : (
                                                                                                    <CustomTooltipComponent title="Collega Unità" placement="top-end" arrow>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="pl-4 text-indigo-700 align-middle"
                                                                                                            onClick={onClickAttach}
                                                                                                        >
                                                                                                            <AddLinkOutlinedIcon className="text-gray-600 bg-indigo-50 rounded-full p-0.5" style={{ width: 25, height: 25 }} />
                                                                                                        </button>
                                                                                                    </CustomTooltipComponent>
                                                                                                );
                                                                                                })()}
                                                                                            </td>
                                                                                            )}

                                                                                            {/* Inizio turno */}
                                                                                            <td className="px-2 py-1 border-b">
                                                                                                <div className="flex items-center gap-2">
                                                                                                    <span>{timeSlot.start_at || ''}</span>
                                                                                                </div>
                                                                                            </td>

                                                                                            {/* Fine turno */}
                                                                                            <td className="px-2 py-1 border-b">{timeSlot.end_at || ''}</td>

                                                                                            {/* Pausa start */}
                                                                                            <td className="px-2 py-1 border-b">
                                                                                                {timeSlot.breaks?.length
                                                                                                    ? timeSlot.breaks.map((b, i) => {
                                                                                                        const isHidden = !(b?.is_visible ?? true);
                                                                                                        return (
                                                                                                        <div
                                                                                                            key={i}
                                                                                                            className={`flex items-center gap-1 ${isHidden ? 'text-gray-400' : 'text-gray-600'}`}
                                                                                                        >
                                                                                                            {isHidden && (
                                                                                                            <EyeSlashIcon className="h-3 w-3 text-red-500" strokeWidth={2} />
                                                                                                            )}
                                                                                                            <span>{b.start_at || ''}</span>
                                                                                                        </div>
                                                                                                        );
                                                                                                    })
                                                                                                    : 'Nessuna pausa'}
                                                                                            </td>

                                                                                            {/* Pausa end */}
                                                                                            <td className="px-2 py-1 border-b">
                                                                                                {timeSlot.breaks?.length
                                                                                                    ? timeSlot.breaks.map((b, i) => {
                                                                                                        const isHidden = !(b?.is_visible ?? true);
                                                                                                        return (
                                                                                                        <div
                                                                                                            key={i}
                                                                                                            className={`flex items-center gap-1 ${isHidden ? 'text-gray-400' : 'text-gray-600'}`}
                                                                                                        >
                                                                                                            {isHidden && (
                                                                                                            <EyeSlashIcon className="h-3 w-3 text-red-500" strokeWidth={2} />
                                                                                                            )}
                                                                                                            <span>{b.end_at || ''}</span>
                                                                                                        </div>
                                                                                                        );
                                                                                                    })
                                                                                                    : 'Nessuna pausa'}
                                                                                            </td>

                                                                                            {/* AZIONI: solo prima riga, sempre con rowSpan. Se niente permessi, celle vuote ma presenti */}
                                                                                            {!isFisso && timeSlotIndex === 0 && (
                                                                                            <>
                                                                                                {/* Conferma */}
                                                                                                <td
                                                                                                className={`px-2 py-1 border-b text-right align-top ${pendingBg}`}
                                                                                                rowSpan={rowSpanSize}
                                                                                                >
                                                                                                {canManageShifts && isPending ? (
                                                                                                    <CustomTooltipComponent title="Conferma turno" placement="top-start" arrow>
                                                                                                    <CheckCircleIcon
                                                                                                        className="h-5 w-5 inline-block cursor-pointer text-indigo-700 hover:text-green-500"
                                                                                                        onClick={() => handleConfirmDWH(shift)}
                                                                                                    />
                                                                                                    </CustomTooltipComponent>
                                                                                                ) : null}
                                                                                                </td>

                                                                                                {/* Elimina */}
                                                                                                <td
                                                                                                className={`px-2 py-1 border-b text-right align-top ${pendingBg}`}
                                                                                                rowSpan={rowSpanSize}
                                                                                                >
                                                                                                {canManageShifts && isMonthOpen ? (
                                                                                                    <CustomTooltipComponent title="Elimina turno" placement="top-start" arrow>
                                                                                                    <TrashIcon
                                                                                                        className="h-5 w-5 inline-block cursor-pointer text-gray-800 hover:text-red-500"
                                                                                                        onClick={() => handleDeleteDailyWh(dipendente, shift)}
                                                                                                    />
                                                                                                    </CustomTooltipComponent>
                                                                                                ) : null}
                                                                                                </td>
                                                                                            </>
                                                                                            )}
                                                                                        </tr>
                                                                                        ));
                                                                                    })}

                                                                                    {(() => {
                                                                                        // Conta DWH pendenti
                                                                                        const pendingCount = (employeeDayDetails?.shifts || []).filter(s => s.status === false).length;

                                                                                        if (employeeDayDetails?.shift_type === 'fisso' || pendingCount < 2 || !canManageShifts) return null;

                                                                                        const actionCols = employeeDayDetails?.shift_type !== 'fisso' ? 2 : 0;
                                                                                        // Stato(1) + Inizio(1) + Fine(1) + Pausa start(1) + Pausa end(1) + azioni(0/2)
                                                                                        const colSpan = 5 + actionCols;

                                                                                        return (
                                                                                        <tr>
                                                                                            <td colSpan={colSpan} className="pt-2 pb-4">
                                                                                            <div className="flex justify-center border-b pt-1 pb-3">
                                                                                                <button
                                                                                                className="me-4 w-28 bg-indigo-600 text-white font-semibold text-xs py-1 px-2 rounded-md"
                                                                                                onClick={() => handleConfirmAllShifts?.(employeeDayDetails)}
                                                                                                >
                                                                                                Conferma tutti
                                                                                                </button>
                                                                                                <button
                                                                                                className="w-28 bg-gray-200 text-gray-700 text-xs font-semibold rounded-md py-1 px-2"
                                                                                                onClick={() => handleDeleteAllShifts?.(employeeDayDetails)}
                                                                                                >
                                                                                                Elimina tutti
                                                                                                </button>
                                                                                            </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                        );
                                                                                    })()}
                                                                                </tbody>
                                                                            </table>
                                                                   
                                                                        </div>
                                                                    ) : (
                                                                        <div className="text-sm text-gray-600 sm:pl-4 lg:pl-0">Nessun turno previsto</div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        ) : null}
                                                        {(canViewInouts || canManageInouts) ? (
                                                            <>
                                                                <div className="font-semibold text-sm text-gray-600 uppercase pt-1 col-span-1">
                                                                    <div>Timbrature</div>

                                                                    {canManageInouts ? (
                                                                        <div className="mt-1">
                                                                            {showAddTimbraturaButton && (
                                                                                <>
                                                                                    {isMonthOpen && (
                                                                                        <CustomTooltipComponent title="Aggiungi" placement="top-start" arrow>
                                                                                            <button
                                                                                                onClick={handleAddNewRow}
                                                                                                className="inline-flex items-center gap-1 rounded bg-indigo-400 px-2 text-xs font-semibold text-white hover:bg-indigo-500 uppercase"
                                                                                            >
                                                                                                <AddOutlinedIcon style={{ width: '1rem', color: 'white' }} />
                                                                                            </button>
                                                                                        </CustomTooltipComponent>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    ) : null}
                                                                </div>
                                                                <div className='col-span-1 sm:col-span-3 lg:col-span-5 overflow-x-auto'>
                                                                    {(inouts && inouts.length > 0) || (newTimbratura && editingId === 'new') ? (
                                                                        <table className="table-auto w-full text-sm overflow-x-auto">
                                                                            <thead>
                                                                                <tr className="bg-gray-100">
                                                                                    <th className="px-2 py-1 text-left">Ingresso</th>
                                                                                    <th className="px-2 py-1 text-left">Uscita</th>
                                                                                    {!editingId && (
                                                                                        <th className="px-2 py-1 text-left">Posizione</th>
                                                                                    )}
                                                                                    <th className="px-2 py-1 text-left"></th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {inouts
                                                                                .sort((a, b) => {
                                                                                    const dateA = a.checkin ? new Date(a.checkin) : new Date(0);
                                                                                    const dateB = b.checkin ? new Date(b.checkin) : new Date(0);
                                                                                    return dateA - dateB;
                                                                                })
                                                                                .map((inout, index) => {
                                                                                    const isEditing = editingId === inout.id;
                                                                                    return (
                                                                                        <tr key={index} className="border-t">
                                                                                            <td className={`px-2 py-1`}>
                                                                                                <div className="flex items-center justify-start h-full">
                                                                                                    {isEditing ? (
                                                                                                        <div className="flex flex-col items-start gap-1">
                                                                                                            <TimeInput
                                                                                                                value={editCheckIn}
                                                                                                                setValue={setEditCheckIn}
                                                                                                                compareValue={editCheckOut}
                                                                                                                setError={() => {}}
                                                                                                            />
                                                                                                            <input
                                                                                                                type="date"
                                                                                                                value={editCheckInDate}
                                                                                                                onChange={(e) => setEditCheckInDate(e.target.value)}
                                                                                                                className="border px-2 py-1 shadow-md rounded w-32 text-sm"
                                                                                                            />
                                                                                                        <div className="flex justify-end w-full md:hidden">
                                                                                                                <CustomTooltipComponent title="Salva" placement="top-start" arrow>
                                                                                                                    <button
                                                                                                                        className="bg-indigo-600 my-1 w-10 h-10 rounded-md shadow-md text-white hover:bg-indigo-500 flex items-center justify-center"
                                                                                                                        onClick={() => handleSaveEdit(inout.id)}
                                                                                                                    >
                                                                                                                        <SaveOutlinedIcon className="w-5 h-5" />
                                                                                                                    </button>
                                                                                                                </CustomTooltipComponent>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <CustomTooltipComponent
                                                                                                                title={inout?.over_time_checkin ? '⚠️ Fuori orario' : '✅ In orario'}
                                                                                                                placement="top-start"
                                                                                                                arrow
                                                                                                            >
                                                                                                                <div className="flex items-center">
                                                                                                                    {inout?.over_time_checkin ? (
                                                                                                                        <RunningWithErrorsOutlinedIcon style={{ height: 20, width: 20, marginRight: 5, color: '#ef4444' }} />
                                                                                                                    ) : (
                                                                                                                        <CheckCircleOutlineOutlinedIcon style={{ height: 20, width: 20, marginRight: 5, color: '#22C55E' }} />
                                                                                                                    )}
                                                                                                                    <span>
                                                                                                                        {inout.checkin
                                                                                                                            ? moment(inout.checkin).isSame(formattedDay, 'day')
                                                                                                                                ? moment(inout.checkin).format('HH:mm')
                                                                                                                                : moment(inout.checkin).format('DD/MM/YYYY HH:mm')
                                                                                                                            : '-'}
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                            </CustomTooltipComponent>
                                                                                                        </>
                                                                                                    )}
                                                                                                </div>
                                                                                            </td>
                                                                                            <td className={`px-2 py-1`}>
                                                                                                <div className="flex items-center justify-start h-full">
                                                                                                    {isEditing ? (
                                                                                                        <div className="flex flex-col items-start gap-1">
                                                                                                            <TimeInput
                                                                                                                value={editCheckOut}
                                                                                                                setValue={setEditCheckOut}
                                                                                                                compareValue={editCheckIn}
                                                                                                                setError={() => {}}
                                                                                                            />
                                                                                                            <input
                                                                                                                type="date"
                                                                                                                value={editCheckOutDate}
                                                                                                                onChange={(e) => setEditCheckOutDate(e.target.value)}
                                                                                                                className="border px-2 py-1 rounded-md shadow-md w-32 text-sm"
                                                                                                            />
                                                                                                            <CustomTooltipComponent title="Annulla" placement="top-start" arrow>
                                                                                                                <button className="md:hidden bg-gray-400 py-1 px-3 my-1 w-20 rounded-md shadow-md text-white font-semibold text-xs uppercase hover:bg-gray-300" onClick={cancelEditing}>
                                                                                                                    <RestartAltOutlinedIcon className="w-5 h-5" />
                                                                                                                </button>
                                                                                                            </CustomTooltipComponent>
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            {inout?.checkout ? (
                                                                                                                <>
                                                                                                                    {inout?.checkout ? (
                                                                                                                        <CustomTooltipComponent
                                                                                                                            title={inout?.over_time_checkout ? '⚠️ Fuori orario' : '✅ In orario'}
                                                                                                                            placement="top-start"
                                                                                                                            arrow
                                                                                                                        >
                                                                                                                            <div className="flex items-center">
                                                                                                                                {inout?.over_time_checkout ? (
                                                                                                                                <RunningWithErrorsOutlinedIcon
                                                                                                                                    style={{ height: 20, width: 20, marginRight: 5, color: '#ef4444' }}
                                                                                                                                />
                                                                                                                                ) : (
                                                                                                                                <CheckCircleOutlineOutlinedIcon
                                                                                                                                    style={{ height: 20, width: 20, marginRight: 5, color: '#22C55E' }}
                                                                                                                                />
                                                                                                                                )}
                                                                                                                                <span>{formatCheckoutTime(inout.checkout, formattedDay)}</span>
                                                                                                                            </div>
                                                                                                                        </CustomTooltipComponent>
                                                                                                                    ) : (
                                                                                                                        <CustomTooltipComponent title="⏳ In corso" placement="top-start" arrow>
                                                                                                                            <div className="flex items-center">
                                                                                                                                <PendingOutlinedIcon
                                                                                                                                    style={{ height: 20, width: 20, marginRight: 5, color: '#f97316' }}
                                                                                                                                />
                                                                                                                                <span>in corso</span>
                                                                                                                            </div>
                                                                                                                        </CustomTooltipComponent>
                                                                                                                    )}
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    <CustomTooltipComponent title="⏳ In corso" placement="top-start" arrow>
                                                                                                                        <div>
                                                                                                                            <PendingOutlinedIcon style={{ height: 20, width: 20, marginRight: 5, color: '#f97316' }} />
                                                                                                                            in corso
                                                                                                                        </div>
                                                                                                                    </CustomTooltipComponent>
                                                                                                                </>
                                                                                                            )}
                                                                                                        </>
                                                                                                    )}
                                                                                                </div>
                                                                                            </td>
                                                                                            {!editingId && (
                                                                                                <td className="px-2 py-1">
                                                                                                    {(inout.checkin_lat && inout.checkin_lng) || (inout.checkout_lat && inout.checkout_lng) ? (
                                                                                                        <span className="text-indigo-800 cursor-pointer" onClick={() => openLocationMap(inout)}>
                                                                                                            <MapPinIcon className="w-5 h-5 inline-block mr-1" /> Mappa
                                                                                                        </span>
                                                                                                    ) : (
                                                                                                        <span className="text-sm text-gray-500 italic">Posizione non registrata</span>
                                                                                                    )}
                                                                                                </td>
                                                                                            )}
                                                                                            {isMonthOpen && (
                                                                                                <td className="px-2 py-1 align-middle min-w-[120px] overflow-x-auto">
                                                                                                    {(!isEmployee || hasManageTimbraturePermission) && (
                                                                                                        <div className="grid grid-cols-3 auto-cols-max gap-3 h-full justify-center items-center">
                                                                                                        
                                                                                                            {isEditing ? (
                                                                                                                <>
                                                                                                                    <CustomTooltipComponent title="Salva" placement="top-start" arrow>
                                                                                                                        <button className="hidden md:block bg-indigo-600 px-2 py-1 rounded-md shadow-md text-white font-semibold text-xs uppercase hover:bg-indigo-500" onClick={() => handleSaveEdit(inout.id)}>
                                                                                                                            <SaveOutlinedIcon className="w-5 h-5" />
                                                                                                                        </button>
                                                                                                                    </CustomTooltipComponent>
                                                                                                                    <CustomTooltipComponent title="Annulla" placement="top-start" arrow>
                                                                                                                        <button className="hidden md:block bg-gray-400 py-1 px-2 rounded-md shadow-md text-white font-semibold text-xs uppercase hover:bg-gray-300" onClick={cancelEditing}>
                                                                                                                            <RestartAltOutlinedIcon className="w-5 h-5" />
                                                                                                                        </button>
                                                                                                                    </CustomTooltipComponent>
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    <div className="flex justify-center items-center">
                                                                                                                        {/* Puoi lasciare vuoto oppure inserire un'icona invisibile se necessario */}
                                                                                                                        <span className="w-5 h-5 min-w-[20px] min-h-[20px] invisible" />
                                                                                                                    </div>
                                                                                                                    <div className='flex justify-center'>
                                                                                                                        <CustomTooltipComponent title="Modifica" placement="top-start" arrow>
                                                                                                                            <PencilSquareIcon className="h-5 w-5 cursor-pointer text-gray-800 hover:text-indigo-800" onClick={() => startEditing(inout)} />
                                                                                                                        </CustomTooltipComponent>
                                                                                                                    </div>
                                                                                                                    <div className='flex justify-center'>
                                                                                                                        <CustomTooltipComponent title="Elimina" placement="top-start" arrow>
                                                                                                                            <TrashIcon className="h-5 w-5 cursor-pointer text-gray-800 hover:text-red-500" onClick={() => handleDeleteTimbratura(inout)} />
                                                                                                                        </CustomTooltipComponent>
                                                                                                                    </div>
                                                                                                                </>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </td>
                                                                                            )}
                                                                                        </tr>
                                                                                    );
                                                                                })}

                                                                                {newTimbratura && editingId === 'new' && (
                                                                                    <tr className="border-t">
                                                                                        <td className="px-2 pt-2 pb-6">
                                                                                            <div className="flex flex-col gap-2 items-start justify-start h-full">
                                                                                                <TimeInput
                                                                                                    value={editCheckIn}
                                                                                                    setValue={setEditCheckIn}
                                                                                                    compareValue={editCheckOut}
                                                                                                    setError={() => {}}
                                                                                                />
                                                                                                <input
                                                                                                    type="date"
                                                                                                    value={editCheckInDate}
                                                                                                    onChange={(e) => setEditCheckInDate(e.target.value)}
                                                                                                    className="border px-2 py-1 shadow-md rounded w-32 text-sm"
                                                                                                />
                                                                                            </div>
                                                                                        </td>

                                                                                        <td className="px-2 pt-2 pb-6">
                                                                                            <div className="flex flex-col gap-2 items-start justify-start h-full">
                                                                                                <TimeInput
                                                                                                    value={editCheckOut}
                                                                                                    setValue={setEditCheckOut}
                                                                                                    compareValue={editCheckIn}
                                                                                                    setError={() => {}}
                                                                                                />
                                                                                                <input
                                                                                                    type="date"
                                                                                                    value={editCheckOutDate}
                                                                                                    onChange={(e) => setEditCheckOutDate(e.target.value)}
                                                                                                    className="border px-2 py-1 shadow-md rounded w-32 text-sm"
                                                                                                />
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className="px-2 pt-2 pb-6">
                                                                                            <div className="flex items-center justify-center gap-3 h-full">
                                                                                                <CustomTooltipComponent title="Salva" placement="top-start" arrow>
                                                                                                    <button className="bg-indigo-600 py-1 px-2 rounded-md shadow-md text-white font-semibold text-xs uppercase hover:bg-indigo-500" onClick={handleSaveNewTimbratura}>
                                                                                                        <SaveOutlinedIcon className="w-5 h-5" />
                                                                                                    </button>
                                                                                                </CustomTooltipComponent>
                                                                                                <CustomTooltipComponent title="Annulla" placement="top-start" arrow>
                                                                                                    <button className="bg-gray-400 py-1 px-2 rounded-md shadow-md text-white font-semibold text-xs uppercase hover:bg-gray-300" onClick={() => { setNewTimbratura(null); cancelEditing(); }}>
                                                                                                        <RestartAltOutlinedIcon className="w-5 h-5" />
                                                                                                    </button>
                                                                                                </CustomTooltipComponent>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    ) : (
                                                                        <div className="text-sm text-gray-600 sm:pl-4 lg:pl-0">Nessuna timbratura disponibile</div>
                                                                    )}
                                                                </div>
                                                                {isLocationModalOpen && (  
                                                                    <div className='col-span-1 col-start-3 flex justify-end'>
                                                                        <button
                                                                            className="ml-4 uppercase font-semibold text-white text-xs px-2 py-1 rounded-md bg-indigo-500 hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600"
                                                                            onClick={closeLocationModal}
                                                                        >
                                                                            Chiudi Mappa
                                                                        </button>
                                                                    </div>   
                                                                )}
                                                                {isLocationModalOpen && (
                                                                    <div className='col-span-6'>
                                                                        <div className='col-span-1'></div>
                                                                        <div className='col-span-5' style={{ height: '70%' }}>
                                                                            <div className="relative" style={{ height: '40vh', width: '100%', marginTop: '5px', marginBottom: '5px' }}>
                                                                                <LocationMap locations={locationData} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : null }

                                                        {isEmployee && !hasManageJustificationPermission ? null : (
                                                            <>
                                                                <div className="font-semibold text-sm text-gray-600 uppercase pt-1 col-span-1">
                                                                    <div>Giustificativi</div>

                                                                    {!isEmployee ||
                                                                        profile.employee?.permissions?.includes('hr.manage_justification_all') ||
                                                                        profile.employee?.permissions?.includes('hr.manage_justification_ou') ? (
                                                                        !newJustificationRow && (
                                                                            <div className="mt-1">
                                                                                {isMonthOpen && (
                                                                                    <CustomTooltipComponent title="Aggiungi" placement="top-start" arrow>
                                                                                        <button
                                                                                            onClick={handleAddNewJustificationRow}
                                                                                            className="inline-flex items-center gap-1 rounded bg-indigo-400 px-2 text-xs font-semibold text-white hover:bg-indigo-500 uppercase"
                                                                                        >
                                                                                            <AddOutlinedIcon style={{ width: '1rem', color: 'white' }} />
                                                                                        </button>
                                                                                    </CustomTooltipComponent>
                                                                                )}
                                                                            </div>
                                                                        )
                                                                    ) : null}
                                                                </div>
                                                                {(justification_requests?.length > 0 || newJustificationRow) ? (
                                                                    <div className="col-span-1 sm:col-span-3 lg:col-span-5">
                                                                        <div className="overflow-x-auto w-full">
                                                                            <table className="table-auto w-full text-sm">
                                                                                <thead>
                                                                                    <tr className="bg-gray-100">
                                                                                        <th className="px-2 py-1 text-left">Descrizione</th>
                                                                                        {!newJustificationRow && (
                                                                                            <th className="px-2 py-1 text-left">Stato</th>
                                                                                        )}
                                                                                        <th className="px-2 py-1 text-left">Dalle Ore</th>
                                                                                        <th className="px-2 py-1 text-left">Alle Ore</th>
                                                                                        <th className="px-2 py-1 text-left"></th>
                                                                                        {newJustificationRow && (
                                                                                            <th className="px-2 py-1 text-left"></th>
                                                                                        )}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {newJustificationRow && (
                                                                                        <>
                                                                                            <tr className="border-t">
                                                                                                <td className="py-1">
                                                                                                    {isLoadingJustification ? (
                                                                                                        'Caricamento...'
                                                                                                    ) : (
                                                                                                        <div className='mt-1 rounded-md z-50 relative border border-gray-300' style={{ maxWidth: '200px'}}>                                                                                       
                                                                                                            <ComboboxAutocomplete
                                                                                                                options={
                                                                                                                    giustificativi
                                                                                                                        .filter(g => {
                                                                                                                            const hasShifts = employeeDayDetails?.shifts?.length > 0;
                                                                                                                            const strategy = g.justification.strategy;
                                                                                                                            return hasShifts || strategy === 'increase' || strategy === null;
                                                                                                                        })
                                                                                                                        .map(g => ({
                                                                                                                            id: g.id,
                                                                                                                            name: g.justification.description,
                                                                                                                            value: g.id,
                                                                                                                            has_hours: g.justification.has_hours,
                                                                                                                        }))
                                                                                                                }
                                                                                                                bgActiveColor="bg-indigo-100"
                                                                                                                textActiveColor="text-gray-900"
                                                                                                                value={selectedJustificationType}
                                                                                                                onChange={handleJustificationTypeChange}
                                                                                                                displayValue={item => item?.name || ''}
                                                                                                                placeholder="Seleziona"
                                                                                                                openDirection="bottom"
                                                                                                                pyClass="py-1"
                                                                                                                zIndex="z-50"
                                                                                                                positionOptions='relative'
                                                                                                                borderClass='border-gray-200 shadow-md'                                                                                                                
                                                                                                            />
                                                                                                        </div>
                                                                                                    )}
                                                                                                </td>
                                                                                                <td className="px-2 pt-2 align-top">
                                                                                                    <TimeInput
                                                                                                        value={editStartTime}
                                                                                                        setValue={setEditStartTime}
                                                                                                        onBlur={() => {
                                                                                                        let val = editStartTime.replace(/\D/g, '').padEnd(4, '0').slice(0, 4);
                                                                                                        const formatted = `${val.slice(0, 2)}:${val.slice(2)}`;
                                                                                                        const isValid = /^([01]?[0-9]|2[0-4]):[0-5][0-9]$/.test(formatted);
                                                                                                        setEditStartTime(isValid ? formatted : '');
                                                                                                        }}
                                                                                                        widthClass="w-24"
                                                                                                        disabled={!selectedJustificationType?.has_hours}
                                                                                                    />
                                                                                                </td>

                                                                                                <td className="px-2 pt-2 align-top">
                                                                                                    <TimeInput
                                                                                                        value={editEndTime}
                                                                                                        setValue={setEditEndTime}
                                                                                                        onBlur={() => {
                                                                                                            let val = editEndTime.replace(/\D/g, '').padEnd(4, '0').slice(0, 4);
                                                                                                            const formatted = `${val.slice(0, 2)}:${val.slice(2)}`;
                                                                                                            const isValid = /^([01]?[0-9]|2[0-4]):[0-5][0-9]$/.test(formatted);
                                                                                                            setEditEndTime(isValid ? formatted : '');
                                                                                                        }}
                                                                                                        widthClass="w-24"
                                                                                                        disabled={!selectedJustificationType?.has_hours}
                                                                                                    />
                                                                                                </td>
                                                                                                <td className="px-2 pt-2 align-top">
                                                                                                    <div className="gap-2 items-center h-full hidden md:flex">
                                                                                                        <CustomTooltipComponent title="Salva" placement="top-start" arrow>
                                                                                                            <button
                                                                                                                className="bg-indigo-600 py-1 px-1 rounded-md shadow-md text-white font-semibold text-xs uppercase hover:bg-indigo-500"
                                                                                                                onClick={handleSaveNewJustification}
                                                                                                            >
                                                                                                                <SaveOutlinedIcon className="w-3 h-3" />
                                                                                                            </button>
                                                                                                        </CustomTooltipComponent>
                                                                                                        <CustomTooltipComponent title="Annulla" placement="top-start" arrow>
                                                                                                            <button
                                                                                                                className="bg-gray-400 py-1 px-1 rounded-md shadow-md text-white font-semibold text-xs uppercase hover:bg-gray-300"
                                                                                                                onClick={() => setNewJustificationRow(false)}
                                                                                                            >
                                                                                                                <RestartAltOutlinedIcon className="w-3 h-3" />
                                                                                                            </button>
                                                                                                        </CustomTooltipComponent>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                            <tr className="md:hidden">
                                                                                                <td colSpan={5} className="px-2 pt-2">
                                                                                                    <div className="flex justify-center gap-2">
                                                                                                        <CustomTooltipComponent title="Salva" placement="top-start" arrow>
                                                                                                            <button
                                                                                                                className="bg-indigo-600 py-1 px-2 rounded-md shadow-md text-white font-semibold text-xs uppercase hover:bg-indigo-500"
                                                                                                                onClick={handleSaveNewJustification}
                                                                                                            >
                                                                                                                <SaveOutlinedIcon className="w-5 h-5" />
                                                                                                            </button>
                                                                                                        </CustomTooltipComponent>
                                                                                                        <CustomTooltipComponent title="Annulla" placement="top-start" arrow>
                                                                                                            <button
                                                                                                                className="bg-gray-400 py-1 px-1 rounded-md shadow-md text-white font-semibold text-xs uppercase hover:bg-gray-300"
                                                                                                                onClick={() => setNewJustificationRow(false)}
                                                                                                            >
                                                                                                                <RestartAltOutlinedIcon className="w-5 h-5" />
                                                                                                            </button>
                                                                                                        </CustomTooltipComponent>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        </>
                                                                                    )}
                                                                                    {justification_requests?.length > 0 && justification_requests
                                                                                        .sort((a, b) => new Date(a.datetime_from) - new Date(b.datetime_from))
                                                                                        .map((justification, index) => {
                                                                                        const isVirtual = justification?.id == null;

                                                                                        // id "logico" della riga: se esiste l'id DB bene, altrimenti fallback stabile
                                                                                        const rowId = isVirtual
                                                                                            ? `virtual-${justification?.justification_id ?? "x"}-${justification?.datetime_from ?? "df"}-${justification?.datetime_to ?? "dt"}-${index}`
                                                                                            : `jr-${justification.id}`;

                                                                                        const isExpanded = expandedRowId === rowId;

                                                                                        return (
                                                                                            <React.Fragment key={rowId}>
                                                                                            <tr
                                                                                                className={`border-t hover:bg-indigo-50 cursor-pointer ${
                                                                                                isExpanded ? "bg-indigo-100" : justification.status === null ? "bg-orange-100" : ""
                                                                                                }`}
                                                                                                onClick={(e) => { 
                                                                                                    e.preventDefault();

                                                                                                    toggleRowExpansion(justification.id)}}
                                                                                            >
                                                                                                    <td className="px-2 py-1 flex items-center gap-1">
                                                                                                        {!isVirtual && (
                                                                                                            <CustomTooltipComponent
                                                                                                                title={
                                                                                                                    justification.note || justification.ou_name
                                                                                                                    ? "Mostra dettagli"
                                                                                                                    : "Nessun dettaglio disponibile. Clicca per modificare"
                                                                                                                }
                                                                                                                placement="top"
                                                                                                                arrow
                                                                                                            >
                                                                                                                {justification.note || justification.ou_name ? (
                                                                                                                    <MarkUnreadChatAltOutlinedIcon className="w-4 h-4 text-indigo-500 hover:text-indigo-700" />
                                                                                                                ) : (
                                                                                                                    <ChatBubbleOutlineOutlinedIcon className="w-4 h-4 text-gray-400 hover:text-indigo-500" />
                                                                                                                )}
                                                                                                            </CustomTooltipComponent>
                                                                                                        )}
                                                                                                        <span>{justification.justification.justification.description}</span>
                                                                                                    </td>
                                                                                                    <td className="px-2 py-1">
                                                                                                        {justification.status === 'approved' ? (
                                                                                                            <CustomTooltipComponent title="Giustificativo approvato" placement="top-start" arrow>
                                                                                                                <CheckCircleOutlineOutlinedIcon
                                                                                                                    style={{ height: '20px', width: '20px', color: '#22C55E' }}
                                                                                                                />
                                                                                                            </CustomTooltipComponent>
                                                                                                        ) : (
                                                                                                            <CustomTooltipComponent title="In attesa di approvazione" placement="top-start" arrow>
                                                                                                                <PendingActionsOutlinedIcon
                                                                                                                    style={{ height: '20px', width: '20px', color: '#f97316' }}
                                                                                                                />
                                                                                                            </CustomTooltipComponent>
                                                                                                        )}
                                                                                                    </td>
                                                                                                    {justification.justification.justification.has_hours ? (
                                                                                                        <>
                                                                                                            <td className="px-2 py-1">{moment(justification.datetime_from).format('HH:mm')}</td>
                                                                                                            <td className="px-2 py-1">
                                                                                                                {moment(justification.datetime_to).format('HH:mm') === '00:00' ? '24:00' : moment(justification.datetime_to).format('HH:mm')}
                                                                                                            </td>
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <td className="px-2 py-1 text-gray-500 italic" colSpan={2}>
                                                                                                            Intera giornata
                                                                                                        </td>
                                                                                                    )}
                                                                                                    <td className="px-2 py-1 align-middle min-w-[120px] overflow-x-auto">
                                                                                                        <div className="grid grid-cols-3 auto-cols-max gap-3 h-full justify-center items-center">
                                                                                                            {!isVirtual && (
                                                                                                                <>
                                                                                                                    {/* Approva */}
                                                                                                                    <div className="flex justify-center">
                                                                                                                        {justification.status === null ? (
                                                                                                                            <CustomTooltipComponent title="Approva giustificativo" placement="top-start" arrow>
                                                                                                                                <CheckBoxOutlinedIcon
                                                                                                                                    className="w-5 h-5 min-w-[20px] min-h-[20px] cursor-pointer text-green-500 hover:text-green-400"
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        handleApproveJustification(justification);
                                                                                                                                    }}
                                                                                                                                />
                                                                                                                            </CustomTooltipComponent>
                                                                                                                        ) : (
                                                                                                                            <span className="w-5 h-5 min-w-[20px] min-h-[20px] invisible" />
                                                                                                                        )}
                                                                                                                    </div>

                                                                                                                    {/* Rifiuta */}
                                                                                                                    {isMonthOpen && (
                                                                                                                        <div className="flex justify-center">
                                                                                                                            {(justification.status === null || justification.status === 'approved') ? (
                                                                                                                                <CustomTooltipComponent title="Rifiuta giustificativo" placement="top-start" arrow>
                                                                                                                                    <DisabledByDefaultOutlinedIcon
                                                                                                                                        className="w-5 h-5 min-w-[20px] min-h-[20px] cursor-pointer text-red-500 hover:text-red-600"
                                                                                                                                        onClick={(e) => {
                                                                                                                                            e.stopPropagation();
                                                                                                                                            handleRejectJustification(justification);
                                                                                                                                        }}
                                                                                                                                    />
                                                                                                                                </CustomTooltipComponent>
                                                                                                                            ) : (
                                                                                                                                <span className="w-5 h-5 min-w-[20px] min-h-[20px] invisible" />
                                                                                                                            )}
                                                                                                                        </div>
                                                                                                                    )}

                                                                                                                    {/* Elimina */}
                                                                                                                    {isMonthOpen && (
                                                                                                                        <div className="flex justify-center">
                                                                                                                            <CustomTooltipComponent title="Elimina giustificativo" placement="top-start" arrow>
                                                                                                                                <TrashIcon
                                                                                                                                    className="w-5 h-5 min-w-[20px] min-h-[20px] cursor-pointer text-gray-800 hover:text-red-500"
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        handleDeleteJustification(justification);
                                                                                                                                    }}
                                                                                                                                />
                                                                                                                            </CustomTooltipComponent>
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                
                                                                                                {justification.id && expandedRowId === justification.id && (
                                                                                                    <>                                                 
                                                                              
                                                                                                        <tr className="bg-gray-50 border-b">
                                                                                                            <td colSpan={6} className="pl-2 md:pr-6 py-2 text-sm text-gray-700">
                                                                                                                <div className="flex justify-between items-center w-full">
                                                                                                                    <div className="flex gap-1 items-center w-full">
                                                                                                                        <span className="text-indigo-700 font-semibold">Note:</span>

                                                                                                                        {editingNoteId === justification.id ? (
                                                                                                                            <input
                                                                                                                                type="text"
                                                                                                                                className="mx-2 flex-1 border border-gray-300 rounded-md px-2 py-1 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-300"
                                                                                                                                value={editingNoteText}
                                                                                                                                onChange={(e) => setEditingNoteText(e.target.value)}
                                                                                                                            />
                                                                                                                        ) : (
                                                                                                                            <span className="text-gray-800 font-semibold ml-1">
                                                                                                                                {justification.note?.trim() || ''}
                                                                                                                            </span>
                                                                                                                        )}
                                                                                                                    </div>
                                                                                                                    {isMonthOpen && (
                                                                                                                        <div className="flex gap-8 items-center">
                                                                                                                            {editingNoteId === justification.id ? (
                                                                                                                                <div className="flex gap-1 items-center">
                                                                                                                                    <CustomTooltipComponent title="Salva nota" placement="top" arrow>
                                                                                                                                        <button
                                                                                                                                        className="bg-indigo-500 hover:bg-indigo-600 px-1.5 py-1 rounded-md shadow text-white transition duration-150 ease-in-out"
                                                                                                                                        onClick={() => handleSaveNote(justification.id)}
                                                                                                                                        >
                                                                                                                                        <SaveOutlinedIcon className="w-[14px] h-[14px]" />
                                                                                                                                        </button>
                                                                                                                                    </CustomTooltipComponent>

                                                                                                                                    <CustomTooltipComponent title="Annulla" placement="top" arrow>
                                                                                                                                        <button
                                                                                                                                        className="bg-gray-300 hover:bg-gray-400 px-1.5 py-1 rounded-md shadow text-white transition duration-150 ease-in-out"
                                                                                                                                        onClick={() => {
                                                                                                                                            setEditingNoteId(null);
                                                                                                                                            setEditingNoteText('');
                                                                                                                                        }}
                                                                                                                                        >
                                                                                                                                        <RestartAltOutlinedIcon className="w-[12px] h-[12px]" />
                                                                                                                                        </button>
                                                                                                                                    </CustomTooltipComponent>
                                                                                                                                </div>
                                                                                                                            ) : (
                                                                                                                                <>
                                                                                                                                    <CustomTooltipComponent title="Modifica nota" placement="top" arrow>
                                                                                                                                        <PencilSquareIcon
                                                                                                                                            className="h-5 w-5 text-gray-800 cursor-pointer hover:text-indigo-500"
                                                                                                                                            onClick={() => {
                                                                                                                                                setEditingNoteId(justification.id);
                                                                                                                                                setEditingNoteText(justification.note || '');
                                                                                                                                            }}
                                                                                                                                        />
                                                                                                                                    </CustomTooltipComponent>
                                                                                                                                    {justification.note?.trim() && (
                                                                                                                                        <CustomTooltipComponent title="Elimina nota" placement="top" arrow>
                                                                                                                                            <TrashIcon
                                                                                                                                                className="h-5 w-5 text-gray-800 cursor-pointer hover:text-red-500"
                                                                                                                                                onClick={() => handleDeleteNote(justification.id)}
                                                                                                                                            />
                                                                                                                                        </CustomTooltipComponent>
                                                                                                                                    )}
                                                                                                                                </>
                                                                                                                            )}
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                        
                                                                                                        {justification?.ou_name ? (
                                                                                                            <tr className="bg-gray-50 border-b">
                                                                                                                <td colSpan={6} className="pl-2 md:pr-6 py-2 text-sm text-gray-700">
                                                                                                                    <div className="flex justify-between items-center w-full">
                                                                                                                    
                                                                                                                        {/* Area testo a sinistra */}
                                                                                                                        <div className="flex gap-1 items-center">
                                                                                                                            <span className="text-indigo-700 font-semibold">Unità organizzativa:</span>
                                                                                                                            <span className="text-gray-800">{justification.ou_name}</span>
                                                                                                                        </div>

                                                                                                                        {/* Area icone a destra */}
                                                                                                                        {isMonthOpen && (
                                                                                                                            <div className="flex gap-8">
                                                                                                                                <CustomTooltipComponent title="Modifica Unità" placement="top" arrow>
                                                                                                                                    <PencilSquareIcon
                                                                                                                                        className="h-5 w-5 text-gray-800 cursor-pointer hover:text-indigo-500"
                                                                                                                                        onClick={() => handleEditOU(justification)}
                                                                                                                                    />
                                                                                                                                </CustomTooltipComponent>
                                                                                                                                <CustomTooltipComponent title="Rimuovi Unità" placement="top" arrow>
                                                                                                                                    <TrashIcon
                                                                                                                                        className="h-5 w-5 text-gray-800 cursor-pointer hover:text-red-500"
                                                                                                                                        onClick={() => handleDeletePairedUnit(justification.id)}
                                                                                                                                    />
                                                                                                                                </CustomTooltipComponent>
                                                                                                                            </div>
                                                                                                                        )}
                                                                                                                    </div>
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        ) : (
                                                                                                            <tr className="bg-gray-50 border-b">
                                                                                                                <td colSpan={6} className="pl-2 md:pr-6 py-2 text-sm text-gray-700">
                                                                                                                    <div className="flex justify-between items-center w-full">
                                                                                                                        <span className="text-indigo-700 font-semibold">Unità organizzativa:</span>
                                                                                                                        {isMonthOpen && (
                                                                                                                            <div className="flex items-center gap-8">
                                                                                                                                <CustomTooltipComponent title="Modifica" placement="top-start" arrow>
                                                                                                                                    <PencilSquareIcon className="h-5 w-5 text-gray-800 cursor-pointer hover:text-indigo-500" onClick={() => handleEditOU(justification)} />
                                                                                                                                </CustomTooltipComponent>
                                                                                                                            </div>
                                                                                                                        )}
                                                                                                                    </div>
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </React.Fragment>
                                                                                            );
                                                                                        })
                                                                                    }
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <span className="text-sm text-gray-600 col-span-1 sm:col-span-3 lg:col-span-5 pt-1 sm:pl-4 lg:pl-0">Nessun giustificativo presente</span>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>

                                                    <div className="pt-2 flex justify-center">
                                                        <button
                                                            type="button"
                                                            className="uppercase w-28 bg-white border border-gray-200 shadow-md text-gray-700 text-sm font-semibold px-4 py-2 rounded-md ml-4 hover:bg-gray-300 focus:outline-none focus:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                            onClick={handleClose}
                                                        >
                                                            CHIUDI
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {/* {showUnitSelection && selectedJustification && (
                                            <OuSelectionPair
                                                onClose={() => setShowUnitSelection(false)} 
                                                justification={selectedJustification}
                                                onSelectOUtoPair={handleSelectOUtoPair}
                                            />
                                        )} */}
                                    </div>
                                </div>
                            </Transition.Child>
                        </div>
                    </Dialog>
                </Transition.Root>  
            </div>
            {showUnitSelection && selectedJustification && (
                <OuSelectionPair
                    onClose={() => setShowUnitSelection(false)} 
                    justification={selectedJustification}
                    onSelectOUtoPair={handleSelectOUtoPair}
                />
            )}
            {openModalShift && formattedDay && (
                <ModalSelectCreateShift 
                    onClose={handleCloseModalShift}
                    selectedDay={formattedDay}
                    selectedEmployee={dipendente}
                    onAssignNewShift={handleUpdateShifts} 
                    allowHiddenBreaks={settingHiddenBreak} 
                />
            )}
            {isModalOuPairingDWHOpen && selectedDWH && (
                <OuSelectionPairDWH 
                    dailyWh={selectedDWH} 
                    onClose={closeModalPairingOuDWH} 
                    onSelectOUtoPair={handleSelectOUtoPairDWH}
                />
            )}
        </>
    )};

export default DayDetailsModal;
